import React, { Component, Fragment } from "react"
// import AlertContainer from 'react-alert';
import "./addNewCustomer.css"
import Modal from "react-responsive-modal"
import AsyncSelect from "react-select"
import Audit from "../../components/Common/audit"
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

//components
import Button from "../../components/Buttons/Button"
import PageHeader from "../../components/Page/PageHeader/PageHeader"
import Field from "../../components/Field/Field"
import Field1 from "../../components/Common/Field/Field"
import {
  CustomerServices,
  UtilityService,
  PermissionServices,
  StyleServices
} from "../../services"
import ButtonIcon from "../../components/Costing/Button/ButtonIcon"
import FileUpload from "../../components/FileUpload/FileUpload"
import Loading from "../../components/Common/Loading"
import Select from "react-select"
import "react-select/dist/react-select.css"
import Picky from "react-picky"
import "react-picky/dist/picky.css" // Include CSS
import AssigmentOfWork from "../../components/Customer/AssignmentOfWork"
import { confirmAlert } from "react-confirm-alert"
import "react-confirm-alert/src/react-confirm-alert.css"
import leftArrowImage from '../../assets/images/left-arrow.png'
//import _ from "lodash"

const assignmentOfWorkTemplate = {
  sample: null,
  cad: null,
  fabric: null,
  trim: null,
  pattern: null,
  cutting: null,
  sewing: null,
  garmentTechnologist: null,
  embellishment: null,
  embroidery: null,
  wash: null,
  dispatch: null,
  qc: null,
  marker: null,
  costing: null,
  signOff: null
}
//console.log("StyleServices:", StyleServices);
//console.log("listStyles method:", StyleServices.getStylePrefilledData);
let ArrayData = [
  {
    status: true,
    name: "Active"
  },
  {
    status: false,
    name: "Inactive"
  }
]

const options = [
  { label: "One", value: 1 },
  { label: "Two", value: 2 },
  { label: "Three", value: 3 }
]

const bigList = []

for (var i = 1; i <= 1000; i++) {
  bigList.push({ id: i, name: `Item ${i}` })
}
class Customer extends Component {
  // LIFE CYCLE START
  state = {
    action: "",
    _id: "",
    disabled: false,
    recentCustomerId: "",
    masSizeType:[],
    searchInput:{},
    originalData: [],     // unmodified full data
    filteredData: [],     // shown in UI
    customer: {
      customerId: "",
      customerName: "",
      customerCode: "",
      customerStatus: true,
      refImages: [],
      sites: [
        {
          officeName: null,
          city: null,
          country: null,
          registeredAddress1: "",
          registeredAddress2: "",
          zipCode: ""
        }
      ],
      fabricBasicRequirements: {
        fixedCharge: null,
        approvedTestingLab: null,
        primaryLightSource: null,
        secondaryLightSource: null,
        attribute: null
      },
      departments: [
        {
          departmentId: null,
          departmentName: "",
          controller: null,
          merchandiser: null,
          juniorMerchandiser: null,
          seniorMerchandiser: null,
          garmentTechnologist: null,
          allSizes: [{ size: null, period: null }],
          priceQuoteMethod: "SINGLE",
          priceQuotesizeSingle: [{ size: null, period: null }],
          priceQuotesizeMultiple: [{ start: null, end: null, period: null }],
          range: [],
          toggle: false,
        isDropdownOpen: false,
        selectedOptions: [],
        garmentTypeOptions: [
          { value: "C1", label: "Back Neck length", garmentType: "Length" },
          { value: "C2", label: "Lorem ipsum", garmentType: "Width" },
          { value: "C3", label: "Lorem ipsum", garmentType: "Length" },
          { value: "C4", label: "Lorem ipsum", garmentType: "Width" },
        ],
          trimPack: [
            {
              trimPackNo: "TP-0001",
              typeOfGmt: null,
              packagingMethod: null,
              packingType: null,
              subType: null,
              trimPackForm: {},
              totalAmount: 0,
              packingTypeDisabled: false,
              subTypeDisabled: false
            }
          ],
          size: [{ minimum: null, maximum: null, period: null }],
          assignmentOfWork: {
            initial: {},
            production: {},
            product: {}
          },
          staff: [
            {
              firstName: "",
              lastName: "",
              designation: "",
              email: "",
              reportingTo: "",
              office: null,
              status: false
            }
          ],
          toggle: true
        }
      ],
      pom: [
        
      ],
      garmentDetails: [],
    },

    deptIndex: 0,
    isLoading: false, //LOADING

    officeOption: [], //OFFICE OPTIONS
    cityOption: [], //CITY OPTIONS
    countryOption: [], //COUNTRY OPTIONS
    statusOption: [],
    approvedTestingLabOption: [], //APPROVED TESTING LAB OPTION
    // primaryLightSourceOption: [], //PRIMARY LIGHT SOURCE OPTION
    // secondaryLightSourceOption: [], //SECONDARY LIGHT SOURCE OPTION
    lightSourceOption: [],
    attributesOption: [], //ATTRIBUTES OPTION
    nameOfDepartmentOption: [],
    designationOption: [], //DESIGNATION OPTION
    reportingToOption: [], //REPORTING TO OPTION
    employeesOption: [],
    empOption1:[],
    rangeOption: [],
    imageTypeOption: [],
    departmentList: [],
    pomList: [],
    typeOfGmtOption: [],
    packagingMethodOption: [],
    packingTypeOption: [],
    subTypeOption: [],
    packagingMaterialsOption: [],
    openModal: false,
    modalType: "",
    assignTextContent: [],
    arrayOfPackagingMaterial: null,
    selected: [],
    multiValue: [],
    preFilledData:[],
    rows: [
     
    ],
    rowId:null,
    selectedOptions: [], // To store the selected options
    isDropdownOpen: false, 
    selectedGarment: "", // Selected garment type
    SHRINKAGETYPEOPTIONS: [],
    GARMENTTYPEOPTIONS: [],
    selectedGarmentType: null,  // Currently selected garment type
    selectedPOM: null,  // Currently selected POM
    selectedOptions: {},  // Selected options for each POM
    selectedOptions1: {}, // Object to track selected options for each POM
    selectAll: false,
    toggleState: {}, // Object to track toggle state by index
    tableToggleState:{},
    row1:[{
      garmentType:null,
      sizeTypeDetails:[]}
    ],
    selectedRows: {},
  }

  componentWillMount() {
    const { action, _id } = this.props.location.state

    this.setState({ action, _id })

    if (_id != "") {
      CustomerServices.getCustomer(_id).then(async response => {
        if (response.status == 200) {
          let customer = { ...this.state.customer }
          Object.keys(customer).forEach(keyname => {
            customer[keyname] = response.text.data[keyname]
          })
          customer.departments = customer.departments.map(department => {
            // department.range = department.range.map((data) => {
            //   return data.value})
            department.trimPack = department.trimPack.map(trimPack => {
              if (trimPack.trimPackForm == undefined) {
                trimPack.trimPackForm = {}
              }
              return trimPack
            })
            return department
          })

          // const pom =  response.text.data.garmentDetails || [];
          // customer.pom = pom;
          // console.log(pom,"from api pm")
          // const garmentDetails = response.text.data.pom || [];
          // customer.garmentDetails = garmentDetails;
          //console.log(pom, "pom");
          const pom = response.text.data.pom || [];
          const garmentDetails = response.text.data.garmentDetails || [];
          //console.log(garmentDetails,"componentwill mount ")

          // this.setState(prevState => {
          //   // Update row1 with the garmentType from garmentDetails
          //   const updatedRow1 = this.state.row1.map((garment, index) => {
          //     // Find the corresponding garmentType in garmentDetails
          //     const garmentDetail = garmentDetails[index];
          
          //     // Update the garmentType in the row1 state
          //     if (garmentDetail) {
          //       return {
          //         ...garment,
          //         garmentType: garmentDetail.garmentType || "" // Update if there's a value, otherwise keep the old one
          //       };
          //     }
          
          //     return garment; // Return the original garment if no match is found
          //   });

          // this.setState(prevState => {
          //   // If row1 is empty, initialize it with garmentType from garmentDetails and sizeTypeDetails as empty array
          //   const updatedRow1 = garmentDetails.map(garmentDetail => ({
          //     garmentType: garmentDetail.garmentType || null, // Set garmentType from garmentDetails or null if it's not present
          //     sizeTypeDetails: [] // Initialize sizeTypeDetails as empty array
          //   }));
          
          //   console.log(updatedRow1, "updaterow1");
          
          //   // Return the updated state with new row1
          //   return {
          //     row1: updatedRow1
          //   };
          // });

          // this.setState(prevState => {
          //   // If garmentDetails is empty, do not update the state
          //   if (!garmentDetails || garmentDetails.length === 0) {
          //     return null;
          //   }
          
          //   // Initialize row1 with garmentType from garmentDetails and sizeTypeDetails as an empty array
          //   const updatedRow1 = garmentDetails.map(garmentDetail => ({
          //     garmentType: garmentDetail.garmentType || null, // Set garmentType from garmentDetails or null if it's not present
          //     sizeTypeDetails: [], // Initialize sizeTypeDetails as an empty array
          //     _id: garmentDetail._id
          //   }));
          
          //   //console.log(updatedRow1, "updatedRow1");
          
          //   // Return the updated state with new row1
          //   console.log(updatedRow1,"row1willmo")
          //   return {
          //     row1: updatedRow1
          //   };
            
            
          // });
          // console.log(this.state.row1,"after up row1")

          // const selectedRows = {};

          // const selectedRows = {};
          // garmentDetails.forEach(garment => {
          //   selectedRows[garment._id] = garment.sizeTypeDetails.map(detail => detail._id);
          // });
          const selectedRows = garmentDetails.map(garment => 
            garment.sizeTypeDetails.map(detail => detail._id)
          );


          this.setState({
            customer,
             pom,
             selectedRows,
            //garmentDetails,
            _id: await response.text.data._id,
            arrayOfPackagingMaterial: await response.text.data.arrayOfPackagingMaterial
          })
        }
        response.status == 401 && this.props.unauthorisedFunc()
      })
    }

    if (action == "view") {
      this.setState({ disabled: true })
    }

    //modal content for assignment of process
    //assignofprocess
    // const assignmodule = [
    //   "Sample",
    //   "CAD",
    //   "Fabric",
    //   "Trim",
    //   "Pattern",
    //   "Cutting",
    //   "Sewing",
    //   "Garment Tech",
    //   "Embellishment",
    //   "Embroidery",
    //   "Wash",
    //   "Dispatch",
    //   "QC",
    //   "Marker",
    //   "Costing",
    //   "Sign Off"
    // ]

    // const assignTextContent = [...this.state.assignTextContent]
    // assignmodule.map((data, i) => {
    //   assignTextContent.push({
    //     modalType: data,
    //     employeeId: ""
    //   })
    // })
    // this.setState({
    //   assignTextContent
    // })
  }

  async componentDidMount() {
    var officeOption = [] //OFFICE OPTIONS
    var cityOption = [] //CITY OPTIONS
    var countryOption = [] //COUNTRY OPTION
    var statusOption = []
    // var primaryLightSourceOption = []; //PRIMARY LIGHT SOURCE OPTION
    // var secondaryLightSourceOption = []; //SECONDARY LIGHT SOURCE OPTION
    var approvedTestingLabOption = [] //APPROVED TESTING LAB OPTION
    var attributesOption = [] //ATTRIBUTES OPTION
    var designationOption = [], //DESIGNATION OPTION
      reportingToOption = [] //REPORTING TO OPTION
    var employeesOption = []
    var rangeOption = []
    var imageTypeOption = []
    var typeOfGmtOption = []
    var packagingMethodOption = []
    var packingTypeOption = []
    var subTypeOption = []
    var packagingMaterialsOption = []
    var lightSourceOption = []
    this.setState({ isLoading: true })

    this.getAssign("")

    if (this.state.action === "add") {
      window.addEventListener("beforeunload", function (event) {
        event.returnValue = "Hellooww"
      })
    }
    
    await StyleServices.getStylePrefilledData().then(async (res) => {
      //console.log(res.text.data,"res")
      this.setState({
        preFilledData: res.text.data,
        SHRINKAGETYPEOPTIONS: res.text.data.SHRINKAGETYPE,
        GARMENTTYPEOPTIONS: res.text.data.GARMENTTYPE
      })
    })

    // await CustomerServices.getPomMaster(this.state._id).then(async data => {
    //   console.log(data.text)
    //   if (data.status == 200) {
    //     this.setState({
    //       rows: data.text.data.measurements,
    //       rowId:data.text.data._id
    //     })
    //   }
    // })

    const {_id } = this.props.location.state

    // if (_id != "") {
    //   CustomerServices.getCustomer(_id).then(async response => {
    //     if (response.status == 200) {
    //       let customer = { ...this.state.customer }
    //       const pom = response.text.data.pom || [];
    //       const garmentDetails = response.text.data.garmentDetails || [];

    //       this.setState(prevState => {
    //         // If garmentDetails is empty, do not update the state
    //         if (!garmentDetails || garmentDetails.length === 0) {
    //           return null;
    //         }
          
    //         // Initialize row1 with garmentType from garmentDetails and sizeTypeDetails as an empty array
    //         const updatedRow1 = garmentDetails.map(garmentDetail => ({
    //           garmentType: garmentDetail.garmentType || null, // Set garmentType from garmentDetails or null if it's not present
    //           sizeTypeDetails: [], // Initialize sizeTypeDetails as an empty array
    //           _id: garmentDetail._id
    //         }));
          
    //         //console.log(updatedRow1, "updatedRow1");
          
    //         // Return the updated state with new row1
    //         console.log(updatedRow1,"row1willmo")
    //         return {
    //           row1: updatedRow1
    //         };
            
            
    //       });
    //       console.log(this.state.row1,"after up row1")
    //       const selectedRows = garmentDetails.map(garment => 
    //         garment.sizeTypeDetails.map(detail => detail._id)
    //       );


    //       this.setState({
    //         customer,
    //          pom,
    //          selectedRows,
    //       })
    //     }
    //     response.status == 401 && this.props.unauthorisedFunc()
    //   })
    // }

    if (this.state._id) {
      try {
        const data = await CustomerServices.getPomMaster(this.state._id);
        if (data.status === 200) {
          // Ensure measurements exist, or use an empty array
          const measurements = data.text.data.measurements || [];
          //console.log(measurements,"mm")
          
          // this.setState(prevState => ({
          //   customer: {
          //     ...prevState.customer,  // Preserve existing customer properties
          //     masSizeType: [...measurements] // Store masSizeType inside customer
          //   }
          // }));
          // console.log(this.state.customer.masSizeType,"chmass")
          this.setState({
            masSizeType: [...measurements] // Store masSizeType separately
          }, () => {
            //console.log(this.state.masSizeType, "Updated masSizeType outside customer");
          });
        }
      } catch (error) {
        console.error("Error fetching Pom Master data:", error);
      }
    }

    if (_id !== "") {
      CustomerServices.getCustomer(_id).then(async response => {
        if (response.status == 200) {
          let customer = { ...this.state.customer };
          const pom = response.text.data.pom || [];
          const garmentDetails = response.text.data.garmentDetails || [];
    
          // Combine both updates in one state change
          this.setState(prevState => {
            // If garmentDetails is empty, do not update the state
            if (!garmentDetails || garmentDetails.length === 0) {
              return null;
            }
            //console.log(this.state.customer,"mas")
            // Initialize row1 with garmentType from garmentDetails and empty sizeTypeDetails
            const updatedRow1 = garmentDetails.map(garmentDetail => ({
              garmentType: garmentDetail.garmentType || null, 
              sizeTypeDetails: this.state.masSizeType,// Initialize sizeTypeDetails as an empty array
              _id: garmentDetail._id
            }));
    
            // Log to check the updated row1
            //console.log(updatedRow1, "row1 after garmentType update");
    
            // Now return the updated state with both row1 and the new pom data
            return {
              row1: updatedRow1,
              customer,
              pom,
            };
          });
        }
        response.status == 401 && this.props.unauthorisedFunc();
      });
    }
    


    if (this.state._id) {
      //console.log(this.state._id,"id in getpom")
      try {
        const data = await CustomerServices.getPomMaster(this.state._id);
        //console.log(data.text.data.measurements,"setsiz")
        if (data.status === 200) {
          //console.log(this.state.row1,"rowsb")
          this.setState(prevState => ({
            customer: {
              ...prevState.customer,
              garmentDetails: [
                ...(prevState.customer.garmentDetails || []), // Fallback to empty array if it's undefined
                ...(this.state.action === "add" 
                  ? [{ sizeTypeDetails: data.text.data.measurements }]  // Add sizeTypeDetails only if action is "add"
                  : [] // Otherwise, add nothing
                )
              ]
            },
            row1: prevState.row1.map(item => ({
              ...item,
              // sizeTypeDetails: [...data.text.data.measurements] // ✅ Insert into each row1 object
              sizeTypeDetails : this.state.masSizeType
            })),
            // masSizeType:[...data.text.data.measurements],
            rows: data.text.data.measurements,
            rowId: data.text.data._id,
            
            
          }));
          //console.log(this.state.masSizeType,"massiz")
          //console.log(this.state.row1,"mastervaluemas")
          // if(this.state.action === "add"){
          //   this.setState(prevState=>({
          //     customer:{
          //       ...prevState.customer,
          //       pom:data.text.data.measurements,
          //     }
          //   }))
          //   console.log("add",this.state.customer.pom)
          // }
        }
      } catch (error) {
        console.error("Error fetching data:", error);
        // Handle error, such as showing a message to the user
      }
    } else {
      console.log("No ID provided, skipping API call.");
      // Handle case where no ID is available (e.g., initialize default state or show a message)
      this.setState({
        rows: [], // Default empty rows
      });
    }

    await CustomerServices.getSystemValuesForCustomer().then(async data => {
      await Promise.all(
        data.data.customer.OFFICE.map(office => {
          officeOption.push({
            label: office.name,
            value: office._id
          })
        })
      )
      //GETTING OFFICE OPTIONS END

      //GETTING CITY OPTIONS START

      await Promise.all(
        data.data.customer.CITY.map(office => {
          cityOption.push({
            label: office.name,
            value: office._id
          })
        })
      )
      //GETTING CITY OPTIONS END

      //GETTING COUNTRY OPTIONS START

      await Promise.all(
        data.data.customer.COUNTRY.map(office => {
          countryOption.push({
            label: office.name,
            value: office._id
          })
        })
      )
      //GETTING COUNTRY OPTIONS END

      //Miscellaneous

      //GETTING Primary Light Source OPTIONS START
      // await Promise.all(
      //   data.data.customer.BUYERPRIMARYLIGHTSOURCE.map(office => {
      //     primaryLightSourceOption.push({
      //       label: office.name,
      //       value: office._id
      //     });
      //   })
      // );
      //GETTING Primary Light Source OPTIONS END
      lightSourceOption = await data.data.customer.LIGHTSOURCE

      //GETTING SECONDARYLIGHTSOURCE OPTIONS START
      // secondaryLightSourceOption = await data.data.customer.SECONDARYLIGHTSOURCE
      //GETTING SECONDARYLIGHTSOURCE OPTIONS END

      //GETTING APPROVEDTESTINGLAB OPTIONS START
      await Promise.all(
        data.data.customer.APPROVEDTESTINGLAB.map(office => {
          approvedTestingLabOption.push({
            label: office.name,
            value: office._id
          })
        })
      )
      //     GETTING APPROVEDTESTINGLAB OPTIONS END

      //     GETTING ATTRIBUTE OPTIONS START
      await Promise.all(
        data.data.customer.ATTRIBUTES.map(office => {
          attributesOption.push({
            label: office.name,
            value: office._id
          })
        })
      )
      //     GETTING APPROVEDTESTINGLAB OPTIONS END

      //STAFF
      //     GETTING DESIGNAITON START
      // await Promise.all(
      //   data.data.customer.DESIGNATION.map(office => {
      //     designationOption.push({
      //       label: office.name,
      //       value: office._id
      //     });
      //   })
      // );
      designationOption = [
        { label: "Asst Buyer", value: "asst buyer" },
        { label: "Buyer", value: "buyer" },
        { label: "Fab Tech", value: "fab tech" },
        { label: "Gmt Techr", value: "gmt tech" }
      ]

      //     GETTING DESIGNAITON END
      //     GETTING REPORTING TO START
      await Promise.all(
        data.data.customer.REPORTINGTO.map(office => {
          reportingToOption.push({
            label: office.name,
            value: office._id
          })
        })
      )

      await Promise.all(
        data.data.customer.RANGE.map(office => {
          rangeOption.push({
            label: office.name,
            value: office._id
          })
        })
      )

      await Promise.all(
        data.data.customer.IMAGETYPE.map(office => {
          imageTypeOption.push({
            label: office.name,
            value: office._id
          })
        })
      )

      await Promise.all(
        data.data.customer.TYPEOFGMT.map(office => {
          typeOfGmtOption.push({
            label: office.name,
            value: office.name
          })
        })
      )

      await Promise.all(
        data.data.customer.PACKAGINGMETHOD.map(office => {
          packagingMethodOption.push({
            label: office.name,
            value: office.name
          })
        })
      )

      await Promise.all(
        data.data.customer.PACKINGTYPE.map(office => {
          packingTypeOption.push({
            label: office.name,
            value: office.name,
            cost: office.cost
          })
        })
      )

      await Promise.all(
        data.data.customer.SUBTYPE.map(office => {
          subTypeOption.push({
            label: office.name,
            value: office.name
          })
        })
      )

      await Promise.all(
        data.data.customer.PACKINGMATERIALS.map(office => {
          packagingMaterialsOption.push({
            name: office.name,
            id: office._id
          })
        })
      )

      if (this.props.location.state.action == "add") {
        let customer = { ...this.state.customer }

        customer.departments = customer.departments.map(dept => {
          Object.keys(dept.assignmentOfWork).map(keyName => {
            dept.assignmentOfWork[keyName] = { ...assignmentOfWorkTemplate }
          })

          dept.trimPack.map(trimpackdata => {
            trimpackdata.trimPackNo = "TP-000" + dept.trimPack.length
            return trimpackdata
          })
          return dept
        })
        this.setState({
          customer
        })
      }

      //GETTING REPORTING TO END

      ArrayData.map(status => {
        statusOption.push({
          label: status.name,
          value: status.status
        })
      })
    })

    this.setState({
      officeOption, //office option
      cityOption, //city options
      statusOption,
      countryOption, //country options
      lightSourceOption, //lightSource
      // primaryLightSourceOption, //PRIMARY LIGHT SOURCE OPTION
      rangeOption, //range option
      // secondaryLightSourceOption, //SECONDARY LIGHT SOURCE OPTION
      approvedTestingLabOption, //APPROVED TESING LAB OPTIONS
      attributesOption, //ATTRIBUTES OPTIONS
      designationOption, //DESIGNATION OPTION
      reportingToOption, //REPORTING TO OPTION
      employeesOption, //employeesOption
      imageTypeOption,
      typeOfGmtOption,
      packagingMethodOption,
      packingTypeOption,
      subTypeOption,
      packagingMaterialsOption,
      isLoading: false
    })

      if (!this.state.customer.pom) {
        this.setState(prevState => ({
          customer: {
            ...prevState.customer,  
            pom: [
              {
                garmentType:null,
                sizeType:[]
              }
            ]  // Only update the pom property
          }
        }));
      }

      console.log(this.state.masSizeType,"test")

      this.setState({
        originalData: this.state.masSizeType,
        filteredData: this.state.masSizeType
      });


      await this.empOptions();
    
    
  }


  // componentDidUpdate(prevProps, prevState) {
  //   if (prevState.row1 !== this.state.row1) {
  //     console.log("Updated row1:", this.state.row1);
  //   }
  // }
  
  
  // LIFE CYCLE END

  componentWillUnmount() {
    if (this.state.action === "add") {
      window.removeEventListener("beforeunload", function (event) {
        event.returnValue = "Hellooww"
      })
    }
  }

  // BASIC ON FORM FIELD CHNAGE
  onInputValChange = (name, val) => {
    let customer = { ...this.state.customer }
    customer[name] = val
    this.setState({ customer })
  }

  //CHNAGE DYNAMIC DEPARTMENT FIELD GROUP
  departmentDynamicChange = (name, val, indexOf) => {
    let customer = { ...this.state.customer }
    customer.departments[indexOf][name] = val
    this.setState({ customer })
  }

  //CHANGE ALLSIZES DEPARTMENT

  allSizesDynamicChange = (name, value, deptIndex, sizeIndex) => {
    let customer = { ...this.state.customer }
    customer.departments[deptIndex].allSizes[sizeIndex][name] = value
    this.setState({
      customer
    })
  }

  addAllSizes = deptIndex => {
    let customer = { ...this.state.customer }
    customer.departments[deptIndex].allSizes.push({
      size: null,
      period: null
    })
    this.setState({
      customer
    })
  }

  removeAllSizes = (deptIndex, sizeIndex) => {
    let customer = { ...this.state.customer }
    customer.departments[deptIndex].allSizes = customer.departments[
      deptIndex
    ].allSizes.filter((data, i) => i != sizeIndex)
    this.setState({
      customer
    })
  }

  //CHANGE DYNAMIC ADDRESS FIELD GROUP

  addressDynamicChange = (name, val, indexOf) => {
    let customer = { ...this.state.customer }
    customer.sites[indexOf][name] = val
    this.setState({ customer })
  }

  staffDynamicChange = (name, val, indexOf, i) => {
    let customer = { ...this.state.customer }
    customer.departments[i].staff[indexOf][name] = val
    this.setState({ customer })
  }

  fabricDynamicChange = (name, val, i, type) => {
    let customer = { ...this.state.customer }
    customer.fabricBasicRequirements[name] = val
    this.setState({ customer })
  }

  //DYNAIMC ADD COUNt

  dynamicAddCount = (e, changeOf, i) => {
    let customer = { ...this.state.customer }
    switch (changeOf) {
      case "department":
        let departmentObj = {
          departmentId: null,
          departmentName: "",
          controller: null,
          merchandiser: null,
          juniorMerchandiser: null,
          seniorMerchandiser: null,
          allSizes: [{ size: null, period: null }],
          garmentTechnologist: null,
          priceQuoteMethod: "SINGLE",
          priceQuotesizeSingle: [{ size: null, period: null }],
          priceQuotesizeMultiple: [{ start: null, end: null, period: null }],
          range: [],
          trimPack: [
            {
              trimPackNo: "TP-0001",
              typeOfGmt: null,
              default: false,
              packagingMethod: null,
              packingType: null,
              subType: null,
              trimPackForm: {},
              totalAmount: 0,
              packingTypeDisabled: false,
              subTypeDisabled: false
            }
          ],
          size: { minimum: null, maximum: null },
          assignmentOfWork: {
            initial: { ...assignmentOfWorkTemplate },
            production: { ...assignmentOfWorkTemplate },
            product: { ...assignmentOfWorkTemplate }
          },
          staff: [
            {
              firstName: "",
              lastName: "",
              designation: null,
              email: "",
              reportingTo: "",
              office: null,
              status: false
            }
          ],
          toggle: false
        }
        customer.departments = customer.departments.map(data => {
          return { ...data, toggle: true }
        })
        customer.departments.push({ ...departmentObj })
        this.setState({ customer }, () => {
          var ele = document.getElementById(
            `dept${this.state.customer.departments.length - 1}`
          )
          ele.scrollIntoView()
        })
        break
      case "staff":
        let staffObj = {
          firstName: "",
          lastName: "",
          designation: null,
          email: "",
          reportingTo: "",
          office: "",
          status: false
        }
        customer.departments[i].staff.push({ ...staffObj })
        this.setState({ customer })
        break
      case "addresses":
        let sitesObj = {
          officeName: "",
          city: null,
          country: null,
          registeredAddress1: "",
          registeredAddress2: "",
          zipCode: ""
        }
        customer.sites.push({ ...sitesObj })
        this.setState({ customer })
        break
          case "pom":
            // let garmentDetails ={
            //   garmentType: null,
            //   sizeType: [],
            // }
            // const garmentDetails = {
            //   garmentType: null,
            //   sizeTypeDetails: [],
            //   _id: Date.now().toString() // Temporary ID for new entries
            // };
        
            // this.setState(prevState => ({
            //   customer: {
            //     ...prevState.customer,
            //     garmentDetails: [...prevState.customer.garmentDetails, garmentDetails]
            //   },
            //   selectedRows: {
            //     ...prevState.selectedRows,
            //     [garmentDetails._id]: []
            //   }
            // }));
            for (let i = 0; i < this.state.row1.length; i++) {
              const row = this.state.row1[i];
              if (!row.garmentType) {
                
                const message = `Garment Type is required`;
                this.props.getalertMessage( "error", message  );
                return;
              }
            }
            const firstSizeTypeDetails = this.state.row1.length > 0 ? this.state.row1[0].sizeTypeDetails : [];
            const garmentDetails = {
              garmentType: null,
              sizeTypeDetails: [...firstSizeTypeDetails],
              // _id: Date.now().toString() // Temporary ID for new entries
            };
            
            // Update the state to add the new garmentDetails to row1 and selectedRows
          //   this.setState(prevState => ({
          //     row1: [...prevState.row1, garmentDetails], // Store in row1 instead of customer.garmentDetail
          //   }));
          //   customer.garmentDetails.push({ ...garmentDetails })  // Push the new pom object
          //   this.setState({ customer }, () => {
          //     var ele = document.getElementById(
          //       `pom${this.state.customer.garmentDetails.length - 1}`
          //     )
          //   if (ele) {
          //     ele.scrollIntoView()  // Scroll to the new pom element
          //   }
          // })  
          this.setState(prevState => ({
            customer: { ...prevState.customer, garmentDetails: [...(customer.garmentDetails || [])] },
            row1: [...prevState.row1, garmentDetails],
          }), () => {
            
  
            
            var ele = document.getElementById(`pom${this.state.row1.length - 1}`);
            if (ele) {
              ele.scrollIntoView();
            }
          });
          break;
      default:
        break
    }
  }

  //DYNAIMC REMOVE COUNt

  dynamicRemoveCount = (e, changeOf, i, index) => {
    let customer = { ...this.state.customer }
    switch (changeOf) {
      case "department":
        customer.departments.splice(i, 1)
        this.setState({ customer })
        break
      case "staff":
        customer.departments[i].staff.splice(index, 1)
        this.setState({ customer })
        break
      case "addresses":
        customer.sites.splice(i, 1)
        this.setState({ customer })
        case "pom":
          // Remove pom at index i
          // customer.garmentDetails.splice(i, 1)
          // this.setState({ customer })
          this.state.row1.splice(i,1)
          // this.state.selectedRows.splice(i,1)
          if (this.state.selectedRows && this.state.selectedRows[i]) {
            this.state.selectedRows.splice(i, 1);
          }
          this.setState({row1:this.state.row1})
          this.props.getalertMessage("error", "Garment pom is removed")  
          break

      default:
        break
    }
  }

  //assign of procee
  getAssign = value => {
    PermissionServices.searchEmploye(value)
      .then(response => {
        if (response.status == 200) {
          this.setState({ employeesOption: response.text.data })
        }
      })
      .catch(error => {
        this.props.getalertMessage("error", error)
      })
  }


  empOptions = value => {
    PermissionServices.searchEmploye(value)
      .then(response => {
        if (response.status == 200) {
          this.setState({ empOption1: response.text.data })
        }
      })
      .catch(error => {
        this.props.getalertMessage("error", error)
      })
  }

  changeAssign = (name, value, index, moduleName) => {
    let customer = { ...this.state.customer }
    customer.departments[this.state.deptIndex].assignmentOfWork[moduleName][
      name
    ] = value ? value.value : null;
    this.setState({
      customer,
    })
  }

  onSave = e => {
    e.preventDefault()

    //Jayaprakash
    let customer = { ...this.state.customer }
    const {selectedRows} = this.state

    // const garmentDetails = this.state.row1.map(garment => ({
    //   //_id: garment._id,
    //   garmentType: garment.garmentType,
    //   sizeTypeDetails: (selectedRows[garment._id] || []).map(id => ({
    //     _id: id,
    //     // Other fields will be populated from row1 data on backend
    //   }))
    // }));
    if(this.state._id !== ""){
    const garmentDetails = this.state.row1.map((garment,index) => ({
      garmentType: garment.garmentType, // Directly use garmentType
      sizeType: (selectedRows[index] || []).map(id => id) // Only the _id values (as strings)
    }));
    //console.log(garmentDetails,"whilesaving")

    customer.pom = garmentDetails
  }


    customer.departments = customer.departments.map(customerDepartment => {
      let data = { ...customerDepartment }
      // if (!!data.garmentTechnologist) {
      //   data.garmentTechnologist = data.garmentTechnologist.value
      // }
      // if (!!data.juniorMerchandiser) {
      //   data.juniorMerchandiser = data.juniorMerchandiser.value
      // }
      // if (!!data.merchandiser) {
      //   data.merchandiser = data.merchandiser.value
      // }
      // if (!!data.seniorMerchandiser) {
      //   data.seniorMerchandiser = data.seniorMerchandiser.value
      // }
      // if (!!data.controller) {
      //   data.controller = data.controller.value
      // }

      if (data.range.length) {
        data.range = data.range.map(obj => {
          return typeof obj == "object" ? obj.value : obj
        })
      }

      Object.keys(data.assignmentOfWork).length > 0 &&
        Object.keys(data.assignmentOfWork).forEach(moduleName => {
          Object.keys(data.assignmentOfWork[moduleName]).length > 0 &&
            Object.keys(data.assignmentOfWork[moduleName]).forEach(keyName => {
              if (
                typeof data.assignmentOfWork[moduleName][keyName] ===
                "object" &&
                data.assignmentOfWork[moduleName][keyName] !== null
              )
                data.assignmentOfWork[moduleName][keyName] =
                  data.assignmentOfWork[moduleName][keyName].value
            })
          return data
        })
      return data
    })

    if (this.state._id !== "") {
      customer._id = this.state._id
    }

    if (
      customer.departments.filter(data => data.departmentName == "").length > 0
    ) {
      this.props.getalertMessage("error", " Department name cannot be empty")
    } else {
      CustomerServices.createCustomer(customer)
        .then(response => {
          if (response.status == 200) {
            let updatedCus = this.state.customer
            updatedCus.departments = updatedCus.departments.map(x => {
              x.toggle = true
              return x
            })

            this.setState({
              _id: response.text.data._id,
              customer: updatedCus
            })

            this.props.getalertMessage("success", response.text.message)
          } else {
            this.props.getalertMessage("error", response.text.message)
          }
          response.status == 401 && this.props.unauthorisedFunc()
        })
        .catch(error => {
          this.props.getalertMessage("error", error.toString())
        })
    }
  }

  updateAsyncValues = (value, name, i) => {
    let customer = { ...this.state.customer }
    customer.departments[i][name]  = value ? value.value : null;
    this.setState({ customer })
  }

  getRefImages = refImages => {
    let customer = { ...this.state.customer }
    customer.refImages = refImages
    this.setState({
      customer
    })
  }

  updateSize = (name, value, index) => {
    let customer = { ...this.state.customer }
    customer.departments[index].size[name] = value
    this.setState({
      customer
    })
  }

  handleDropdownChange = (event) => {
    this.setState({ selectedGarment: event.target.value });
  };

  _handleInputChangeTrimPack = (name, value, index) => {
    let customer = { ...this.state.customer }
    if (name === "default") {
      let trimPack = customer.departments[this.state.deptIndex].trimPack
      trimPack.map((x, i) => {
        if (i == index) {
          x.default = true
        } else {
          x.default = false
        }
      })
      customer.departments[this.state.deptIndex].trimPack = trimPack
    } else {
      customer.departments[this.state.deptIndex].trimPack[index][name] = value
    }


    // if(customer.departments[this.state.deptIndex].trimPack[index].packagingMethod === 'HANGING' && customer.departments[this.state.deptIndex].trimPack[index].typeOfGmt !== undefined ){
    //   customer.departments[this.state.deptIndex].trimPack[index].packingTypeDisabled = true
    //   customer.departments[this.state.deptIndex].trimPack[index].subTypeDisabled = true
    // } else if(name == 'packingType' && (value == 'WITH HANGER ' || value == 'WITHOUT HANGER'))
    //   customer.departments[this.state.deptIndex].trimPack[index].subTypeDisabled = true
    // else if (customer.departments[this.state.deptIndex].trimPack[index].typeOfGmt !== undefined && customer.departments[this.state.deptIndex].trimPack[index].packagingMethod === 'BOXED' && customer.departments[this.state.deptIndex].trimPack[index].packingType === ('WITH HANGER' || 'WITHOUT HANGER') )
    // customer.departments[this.state.deptIndex].trimPack[index].subTypeDisabled = true

    // else{
    //   customer.departments[this.state.deptIndex].trimPack[index].packingTypeDisabled = false
    //   customer.departments[this.state.deptIndex].trimPack[index].subTypeDisabled = false
    // }

    this.setState({
      customer
    })
  }

  addTrimPack = deptIndex => {
    let customer = { ...this.state.customer }
    customer.departments[deptIndex].trimPack.push({
      trimPackNo:
        "TP-000" + (customer.departments[deptIndex].trimPack.length + 1),
      default: false,
      typeOfGmt: null,
      packagingMethod: null,
      packingType: null,
      subType: null,
      trimPackForm: {},
      totalAmount: 0
    })

    this.setState({
      customer
    })
  }

  removeTrimPack = (deptIndex, trimPackIndex) => {
    let customer = { ...this.state.customer }
    customer.departments[deptIndex].trimPack = customer.departments[
      deptIndex
    ].trimPack.filter((data, ind) => trimPackIndex != ind)
    this.setState({
      customer
    })
  }

  handleChangePackaging = (name, value, index) => {
    let customer = { ...this.state.customer }
    customer.departments[this.state.deptIndex].trimPack[index].trimPackForm[
      name
    ] = value

    this.setState({
      customer
    })
  }

  updateCalcPackaging = index => {
    let customer = { ...this.state.customer }
    customer.departments[this.state.deptIndex].trimPack[index].totalAmount = 0
    Object.keys(
      customer.departments[this.state.deptIndex].trimPack[index].trimPackForm
    ).forEach(keyName => {
      if (
        customer.departments[this.state.deptIndex].trimPack[index].trimPackForm[
        keyName
        ] !== null
      ) {
        customer.departments[this.state.deptIndex].trimPack[
          index
        ].totalAmount = (
          Number(
            customer.departments[this.state.deptIndex].trimPack[index]
              .totalAmount
          ) +
          Number(
            parseFloat(
              customer.departments[this.state.deptIndex].trimPack[index]
                .trimPackForm[keyName]
            )
          )
        ).toFixed(2)
      }
    })
    this.setState({
      customer
    })
  }

  addPackagingMaterial = index => {
    let customer = { ...this.state.customer }

    let trimePackFormTempString = JSON.stringify(
      customer.departments[this.state.deptIndex].trimPack[index].trimPackForm
    )
    let trimePackFormTemp = JSON.parse(trimePackFormTempString)

    customer.departments[this.state.deptIndex].trimPack[index].trimPackForm = {}

    this.state.arrayOfPackagingMaterial[this.state.deptIndex][index].map(
      value => {
        if (trimePackFormTemp[value.name] === undefined) {
          customer.departments[this.state.deptIndex].trimPack[
            index
          ].trimPackForm[value.name] = null
        } else {
          customer.departments[this.state.deptIndex].trimPack[
            index
          ].trimPackForm[value.name] = trimePackFormTemp[value.name]
        }
        // if(!customer.departments[this.state.deptIndex].trimPack[index].trimPackForm.hasOwnProperty(value.name)){
        // customer.departments[this.state.deptIndex].trimPack[index].trimPackForm[
        //   value.name
        // ] = null
        // }
      }
    )

    this.setState(
      {
        customer
        // arrayOfPackagingMaterial: []
        // [`selectOpen${index}`] : false
      },
      () => this.updateCalcPackaging(index)
    )
  }

  removeTrimPackForm = (name, index) => {
    let state = { ...this.state }
    let { customer, arrayOfPackagingMaterial } = state
    arrayOfPackagingMaterial[this.state.deptIndex][index] = arrayOfPackagingMaterial[this.state.deptIndex][index].filter(
      x => x.name !== name
    )

    delete customer.departments[this.state.deptIndex].trimPack[index]
      .trimPackForm[name]
    this.setState(
      {
        customer,
        arrayOfPackagingMaterial
      },
      () => this.updateCalcPackaging(index)
    )
  }
  // handleMultiChange = (option) => {
  //   this.setState(state => {
  //     return {
  //       multiValue: option
  //     };
  //   });
  // }

  //price quote size single
  updatePriceQuoteSizeSingle = (name, value, deptIndex, index) => {
    let customer = { ...this.state.customer }
    customer.departments[deptIndex].priceQuotesizeSingle[index][name] = value
    this.setState({
      customer
    })
  }

  //price quote size multiple
  priceQuoteSizeMultiDynamicChange = (name, value, deptIndex, sizeIndex) => {
    let customer = { ...this.state.customer }
    customer.departments[deptIndex].priceQuotesizeMultiple[sizeIndex][
      name
    ] = value
    this.setState({
      customer
    })
  }

  addPriceQuoteSizeMulti = deptIndex => {
    let customer = { ...this.state.customer }
    customer.departments[deptIndex].priceQuotesizeMultiple.push({
      start: null,
      end: null,
      period: null
    })
    this.setState({
      customer
    })
  }

  removePriceQuoteSizeMulti = (deptIndex, sizeIndex) => {
    let customer = { ...this.state.customer }
    customer.departments[
      deptIndex
    ].priceQuotesizeMultiple = customer.departments[
      deptIndex
    ].priceQuotesizeMultiple.filter((data, i) => i != sizeIndex)
    this.setState({
      customer
    })
  }

  selectMultipleOption = (value, trimPackIndex) => {
    const updateArrayOfPackagingMaterial = {
      ...this.state.arrayOfPackagingMaterial
    }

    updateArrayOfPackagingMaterial[this.state.deptIndex] = {
      ...updateArrayOfPackagingMaterial[this.state.deptIndex],
      [trimPackIndex]: [...value]
    }

    this.setState({ arrayOfPackagingMaterial: updateArrayOfPackagingMaterial })
  }

  changeToggleList = i => {
    let customer = { ...this.state.customer }
    customer.departments[i].toggle = !customer.departments[i].toggle
    this.setState({
      customer
    })
  }

  //scroll
  // scrollToModule = (id,index) => {
  //   let moduleEle = document.getElementById(id)
  //   moduleEle.scrollIntoView({ behavior: "smooth", block: "start" });

  //   this.setState(prevState => ({
  //     toggleState: { [index]: true},
  //     tableToggleState: { [index]:true}
  //   }))
  // }
  scrollToModule = (id, index) => {
    this.setState(
      prevState => ({
        toggleState: { [index]: true },
        tableToggleState: { [index]: true }
      }),
      () => {
        // Ensure state update is applied first, then scroll
        let moduleEle = document.getElementById(id);
        if (moduleEle) {
          moduleEle.scrollIntoView({ behavior: "smooth", block: "start" });
        }
      }
    );
  };
  

 

  onPomSave = async () => {
    const { rows, _id } = this.state;

    if (rows.length === 0) {
      this.props.getalertMessage("error", "There is nothing in the POM Master to save.");
      return;
    }

  // Validate each row
  for (let i = 0; i < rows.length; i++) {
    const row = rows[i];
    // console.log(row,"val")
    if (!row.code && !row.placeofMeasurement) {
      // Throw error message for the first invalid row
      const message = `Row ${i + 1} is missing required fields.`;
      this.props.getalertMessage( "error", message  );
      return;
    }
  }
  
    const payload = {
      customerId: _id,
      measurements: rows.map((row) => ({
        code: row.code,
        placeofMeasurement: row.placeofMeasurement,
        shrinkageType: row.shrinkageType,
        _id: row._id
      })),
      id:this.state.rowId
    };
    //console.log(payload,"pay")
  
    try {
      const response = await CustomerServices.createpomMaster(payload);
      //console.log(response.text.data._id,"res cus")
  
      if (response.status === 200) {
        const newData = response.text.data;
        this.props.getalertMessage("success", "POM Master saved");
        //console.log(newData.measurements,"newmap")
  
        // Update ONLY the master list of available POMs
        this.setState(prevState => ({
          rows: newData.measurements,
          // row1: newData.measurements.map(item => ({
          //   ...item,
          //   sizeTypeDetails: item.sizeTypeDetails || [] // Ensure sizeTypeDetails exists
          // })),
          row1: prevState.row1.map(item => ({
            ...item,
            // sizeTypeDetails: [...newData.measurements] // ✅ Insert into each row1 object
            sizeTypeDetails: newData.measurements.map(row => ({ ...row })) // ✅ Creates new objects
          })),
          rowId: newData._id
        }));
        //console.log(this.state.row1,"row1whsavpom")
      }
       else {
        this.props.getalertMessage("error", response.text.message);
      }
  
      if (response.status === 401) {
        this.props.unauthorisedFunc();
      }
    } catch (error) {
      this.props.getalertMessage("error", error.toString());
    }
  };
  

  handleRowChange = (field, value, index) => {
    this.setState((prevState) => {
      // const rows = [...prevState.rows];
      // rows[index][field] = value;
      // return { rows };
      const rows = prevState.rows.map((row, i) =>
        i === index ? { ...row, [field]: value } : row // ✅ Creates a new object
      );
  
      return { rows }; 
    });
  };

  addRow = () => {
    const { rows } = this.state;

  // Validate each row
  for (let i = 0; i < rows.length; i++) {  // If BOTH fields are empty, show an error
    const row = rows[i];
    if (!row.code && !row.placeofMeasurement) {
      // Throw error message for the first invalid row
      const message = `Row ${i + 1} is missing required fields.`;
      this.props.getalertMessage( "error", message  );
      return;
    }
  }

    this.setState((prevState) => ({
      rows: [
        ...prevState.rows,
        { code: "", placeofMeasurement: "", shrinkageType: "" },
      ],
    }));
  };

  deleteRow = (index) => {
    this.setState((prevState) => ({
      rows: prevState.rows.filter((_, i) => i !== index),
    }));
    this.props.getalertMessage("error", "row is removed")
  };

 // Toggle dropdown visibility
 toggleDropdown = (index) => {
  const { customer } = this.state;
  customer.departments[index].isDropdownOpen = !customer.departments[index].isDropdownOpen;
  this.setState({ customer });
};

// Handle checkbox selection
handleOptionChange = (index, value) => {
  const { customer } = this.state;
  const department = customer.departments[index];
  const selectedOptions = [...department.selectedOptions];

  if (selectedOptions.includes(value)) {
    const optionIndex = selectedOptions.indexOf(value);
    selectedOptions.splice(optionIndex, 1); // Remove the option
  } else {
    selectedOptions.push(value); // Add the option
  }

  department.selectedOptions = selectedOptions;
  this.setState({ customer });
};

handleGarmentTypeSelection = (garmentType) => {
  this.setState({ selectedGarmentType: garmentType, selectedPOM: null, selectedOptions: {} });
};

handlePomSelection = (pomName) => {
  this.setState({ selectedPOM: pomName });
};



handlePomChange = (field, value, index) => {
  // Copy the existing garmentDetails
  const updatedRow1 = [...this.state.row1];

  // Ensure the row exists and update the field
  if (updatedRow1[index]) {
    updatedRow1[index][field] = value;
  } else {
    console.warn(`Row at index ${index} does not exist.`);
  }

  // Update the state
  this.setState({ 
    // row1: [{
    //   ...this.state.customer,
    //   garmentDetails: updatedGarmentDetails
    // }]
     row1: updatedRow1 
  }, () => {
    //console.log(`Updated garmentDetails:`, this.state.row1);
  });
};

getGarmentTypeLabel = (garmentTypeId) => {
  const option = this.state.GARMENTTYPEOPTIONS.find(option => option.value === garmentTypeId);
  return option ? option.label : null;
};



// handleRowSelect = (garmentId, sizeTypeId, isChecked) => {
//   const { selectedRows } = this.state;

//   // Clone the current state to avoid direct mutation
//   const updatedSelectedRows = { ...selectedRows };

//   // Initialize an array for the garment if it doesn't exist
//   if (!updatedSelectedRows[garmentId]) {
//     updatedSelectedRows[garmentId] = [];
//   }

//   // Add or remove the `sizeTypeId` based on the checkbox state
//   if (isChecked) {
//     if (!updatedSelectedRows[garmentId].includes(sizeTypeId)) {
//       updatedSelectedRows[garmentId].push(sizeTypeId);
//     }
//   } else {
//     updatedSelectedRows[garmentId] = updatedSelectedRows[garmentId].filter(
//       (id) => id !== sizeTypeId
//     );
//   }

//   // Update the state with the new selected rows
//   this.setState({ selectedRows: updatedSelectedRows });
// };


handleRowSelect = (rowIndex, sizeTypeId, isChecked) => {
  const updatedSelectedRows = [...this.state.selectedRows];

  // Ensure the row index exists
  if (!updatedSelectedRows[rowIndex]) {
    updatedSelectedRows[rowIndex] = [];
  }

  // Add or remove the `sizeTypeId` based on the checkbox state
  if (isChecked) {
    if (!updatedSelectedRows[rowIndex].includes(sizeTypeId)) {
      updatedSelectedRows[rowIndex].push(sizeTypeId);
    }
  } else {
    updatedSelectedRows[rowIndex] = updatedSelectedRows[rowIndex].filter(
      (id) => id !== sizeTypeId
    );
  }

  // Update the state
  this.setState({ selectedRows: updatedSelectedRows });
};


// handleSelectAll = (pomIndex, rows) => {
//   this.setState((prevState) => {
//     const pomList = [...prevState.customer.pom];
//     const currentPom = pomList[pomIndex];
//     const isSelected = currentPom.sizeType.length === rows.length;

//     // Select all or clear all
//     currentPom.sizeType = isSelected ? [] : rows.map((row) => row._id);

//     return { pom: pomList };
//   });
// };

// handleSelectAll = (rowIndex, rows) => {
//   const updatedSelectedRows = [...this.state.selectedRows];
  
//   // Check if all sizeTypeIds need to be selected
//   const allIds = rows.map(row => row._id); // assuming each row has an _id field

//   // If the current rowIndex doesn't have selected rows, initialize it
//   if (!updatedSelectedRows[rowIndex]) {
//     updatedSelectedRows[rowIndex] = [];
//   }

//   // If checkbox is selected, select all the IDs for this row
//   updatedSelectedRows[rowIndex] = allIds;

//   // Update the state
//   this.setState({ selectedRows: updatedSelectedRows });
// };

handleSelectAll = (rowIndex, rows) => {
  const updatedSelectedRows = [...this.state.selectedRows];
  
  // Check if we are selecting or unselecting
  const isAllSelected = (updatedSelectedRows[rowIndex] || []).length === rows.length;

  if (isAllSelected) {
    // If all are selected, unselect all
    updatedSelectedRows[rowIndex] = [];
  } else {
    // Otherwise, select all
    const allIds = rows.map(row => row._id); // assuming each row has an _id field
    updatedSelectedRows[rowIndex] = allIds;
  }

  // Update the state
  this.setState({ selectedRows: updatedSelectedRows });
};

// handleToggle = (index) => {
//   this.setState((prevState) => ({
//     toggleState: {
//       ...prevState.toggleState,
//       [index]: !prevState.toggleState[index], // Toggle the current index
//     },
//   }));
// };


handleToggle = (index) => {
  this.setState((prevState) => {
    const newToggleState = {
      ...prevState.toggleState,
      [index]: !prevState.toggleState[index], // Toggle the garment section
    };

    // If opening, also open isTableToggled for this index
    if (newToggleState[index]) {
      return {
        toggleState: newToggleState,
        tableToggleState: {
          ...prevState.tableToggleState,
          [index]: true, // Automatically open the table
        },
      };
    }

    return {
      toggleState: newToggleState,
    };
  });
};


renderShrinkageTypeLabel = (id) => {
  const { SHRINKAGETYPEOPTIONS } = this.state;
  if (!SHRINKAGETYPEOPTIONS) return "Loading...";
  //console.log(SHRINKAGETYPEOPTIONS,"SHRINKAGETYPEOPTIONS")

  const type = SHRINKAGETYPEOPTIONS.find((item) => item.value === id); 
  //console.log(type, "type")
  return type ? type.label : ""; 
};


tableToggle = (index) => {
  this.setState((prevState) => ({
    tableToggleState: {
      ...prevState.tableToggleState,
      [index]: !prevState.tableToggleState[index], // Toggle the current index
    },
  }));
};

preventLeadingSpaces = (value) => {
  // if (value.startsWith(" ")) {
  //   return value.trimStart(); // Remove leading spaces
  // }
  // return value;
  // Remove leading spaces
  value = value.trimStart();

  // Replace multiple spaces between words with a single space
  return value.replace(/\s+/g, " ");
};



seperateGarmentPomSave = (e, index) => {
  e.preventDefault();
  const { row1, selectedRows } = this.state;
  console.log(row1,"saver1")
  const pomData = row1[index];
  console.log(pomData,"save")
  const payload = {
    pom:[
      {
    garmentType: pomData.garmentType,
    // sizeType: (selectedRows[index] || []).map(id => ({
    //   _id: id,
    // })),
    sizeType: selectedRows[index] || [],
    _id: pomData._id,
  },
  ]
  };

  // CustomerServices.garmentPomSave(payload,this.state._id)
  //   .then(response=>{
  //     console.log(response,"saveres")
  //     if(response.status === 200){
  //       const newData = response.text.data.pom
  //       this.setState(prevState => ({
  //         // rows: newData.measurements,
  //         // row1: newData.measurements.map(item => ({
  //         //   ...item,
  //         //   sizeTypeDetails: item.sizeTypeDetails || [] // Ensure sizeTypeDetails exists
  //         // })),
  //         row1: prevState.row1.map(item => ({
  //           ...item,
  //           // sizeTypeDetails: [...newData.measurements] // ✅ Insert into each row1 object
  //           // sizeTypeDetails: newData.map(row => ({ ...row })) // ✅ Creates new objects
  //         })),
  //         rowId: newData._id
  //       }));
  //       console.log(this.state.row1,"row1")
  //       this.props.getalertMessage("success", "Garment POM saved");
  //     }else{
  //       this.props.getalertMessage("error", "Error saving Garment POM")
  //     }
  //   })
  CustomerServices.garmentPomSave(payload, this.state._id)
  .then(response => {
    if (response.status === 200) {
      const newData = response.text.data.pom; // Ensure response contains updated pom data

      this.setState(prevState => ({
        row1: prevState.row1.map(row => {
          // Find the corresponding updated data
          const updatedPom = newData.find(pomItem => pomItem.garmentType === row.garmentType);
          
          // If a match is found, update _id and sizeType
          return updatedPom ? { ...row, _id: updatedPom._id, } : row;
        })
      }));

      this.props.getalertMessage("success", "Garment POM saved");
    } else {
      this.props.getalertMessage("error", response.text.message);
    }
  });
}



hasPermission = (module, action, platform = "web") => {
  const { rights } = this.props; // Get rights from props

  // Check if the module exists in rights
  if (rights && rights[module] && rights[module][platform]) {
      return rights[module][platform][action] || false;
  }

  return false; // Default to false if any part is missing
};



// hasPermission1 = (module,subModule, action, platform = "web") => {
//   const { rights } = this.props; // Get rights from props

//   // Check if the module exists in rights
//   if (rights && rights[module] && rights[module][platform]) {
//       return rights[module][subModule][platform][action] || false;
//   }

//   return false; // Default to false if any part is missing
// };


hasPermission1 = (module, subModule, action, platform = "web") => {
  const { rights } = this.props; // Get rights from props

  // Replace "add" with "create"
  const normalizedAction = action === "add" ? "create" : action;

  // Check if the module exists in rights
  if (rights && rights[module] && rights[module][platform]) {
      return rights[module][subModule][platform][normalizedAction] || false;
  }

  return false; // Default to false if any part is missing
};





//this.props.rights.customer.masterpom.create



garmentPomDelete1 = async (index) => {
  //console.log(CustomerServices);
//console.log(typeof CustomerServices.garmentPomDelete);

  const { row1, selectedRows, _id } = this.state;
  const pomData = row1[index];
  //console.log('pomData:', pomData, 'row1[index]:', row1[index], 'index:', index);

  if (!pomData || !pomData._id) {
    this.state.row1.splice(index,1)
          // this.state.selectedRows.splice(index,1)
          if (this.state.selectedRows && this.state.selectedRows[i]) {
            this.state.selectedRows.splice(i, 1);
          }
          this.setState({row1:this.state.row1})
          this.props.getalertMessage("error", "Garment pom is removed") 
    return;
  }

  
  CustomerServices.garmentPomDelete(this.state._id, pomData._id)
  .then(response => {
    console.log(response,"delres")
    if (response.status === 200) {
      this.setState((prevState) => {
        const updatedRow1 = [...prevState.row1];
        this.state.selectedRows.splice(index,1)
        updatedRow1.splice(index, 1);
        console.log(updatedRow1,"121")
        return { row1: updatedRow1 };
      });

      this.props.getalertMessage("success", "Garment POM deleted successfully");
    } else {
      this.props.getalertMessage("error", "Error deleting Garment POM");
    }
  })
  .catch(error => {
    console.error("Error deleting Garment POM:", error);
    this.props.getalertMessage("error", "Something went wrong while deleting Garment POM");
  });
};





 handleBackNavigation = () => {
  confirmAlert({
    customUI: ({ onClose }) => (
      <div className="p-5 text-center">
        <button
          onClick={onClose}
          className="close"
          style={{ position: "absolute", right: "40px", top: "15px" }}
        >
          X
        </button>
        <h2>Are you sure you want to leave</h2>
        <p>Make sure your changes are saved</p>
        <button
          type="button"
          className="primary"
          style={{ width: "20%", marginRight: "10px" }}
          onClick={() => {
            onClose();
            this.navigateBack();
          }}
        >
          Yes
        </button>
        <button type="button" className="primary" style={{ width: "20%" }} onClick={onClose}>
          No
        </button>
      </div>
    ),
    closeOnClickOutside: false,
  });
};

 navigateBack = () => {
  const state = this.props.history.location.state;
  const route = state && state.route; // Avoids optional chaining

  if (route !== undefined) {
    this.props.history.push(`/${route}`, {
      [route.toLowerCase()]: state[route.toLowerCase()] || {},
    });
  } else {
    this.props.history.goBack();
  }
};


// handleSearchChange = (index, value) => {
//   this.setState((prevState) => ({
//     searchQueries: { ...prevState.searchQueries, [index]: value },
//   }));
// };

// handleSearchClear = (index) => {
//   this.setState((prevState) => ({
//     searchQueries: { ...prevState.searchQueries, [index]: "" },
//   }));
// };


handleSearchChange = (value, index) => {
  this.setState(prevState => ({
    searchInput: {
      ...prevState.searchInput,
      [index]: value,
    }
  }));
}



// handleSearchChange = (value, index) => {
//   this.setState(prevState => {
//     const updatedSearchInput = {
//       ...prevState.searchInput,
//       [index]: value
//     };

//     const filteredData = this.getFilteredData(prevState.originalData, updatedSearchInput[index]);

//     return {
//       searchInput: updatedSearchInput,
//       filteredData
//     };
//   });
// };


// clearSearch = (index) => {
//   this.setState(prevState => ({
//     searchInput: {
//       ...prevState.searchInput,
//       [index]: "",
//     }
//   }));
// }



clearSearch = (index) => {
  this.setState(prevState => {
    const updatedSearchInput = { ...prevState.searchInput, [index]: "" };
    return {
      searchInput: updatedSearchInput,
      filteredData: prevState.originalData
    };
  });
};

// Function to filter data based on search input
// getFilteredData = (data, searchInput) => {
//   if (!searchInput) return data; // Show all data when search is empty
//   const lowercasedInput = searchInput.toLowerCase();

//   return data.filter(option =>
//     option.code.toLowerCase().includes(lowercasedInput) ||
//     option.placeofMeasurement.toLowerCase().includes(lowercasedInput)
//   );
// };


// getFilteredData = (data, searchInput) => {
//   //console.log('Search Input:', searchInput);
//   if (!searchInput) return data; // Show all data when search is empty

//   const lowercasedInput = searchInput.toLowerCase().trim();
//   //console.log('Lowercased Search Input:', lowercasedInput);

//   const filteredData = data.filter(option => 
//     option.code.toLowerCase().includes(lowercasedInput) ||
//     option.placeofMeasurement.toLowerCase().includes(lowercasedInput)
//   );
  
//   //console.log('Filtered Data:', filteredData);
//   return filteredData;
// }


getFilteredData = (data, searchInput) => {
  if (!searchInput || searchInput.trim() === "") return data;

  const lowercasedInput = searchInput.toLowerCase().trim();

  const filteredData = data.filter(option =>
    (option.code && option.code.toLowerCase().includes(lowercasedInput)) ||
    (option.placeofMeasurement && option.placeofMeasurement.toLowerCase().includes(lowercasedInput))
  );

  return filteredData;
};











  render() {
    const { customer, employeesOption, rangeOption, rows, pom, selectedGarmentType, selectedPOM, selectedOptions1, selectAll, row1} = this.state
    //console.log(this.state.SHRINKAGETYPEOPTIONS)
    //console.log(this.state.row1,"row1")
    //console.log(this.state.selectedRows,"selectedRows")
    // console.log(this.props,"prop");
    // console.log(this.state.action,"curig")
    //console.log(this.state.customer,"cus")
    const currentPOM = selectedPOM
      ? customer.pom.find((pomItem) => pomItem.garmentType === selectedPOM)
      : null;
      //console.log(this.state.row1,"rendeerr")
      //console.log(this.getFilteredData(),"meth")
      //console.log(this.state.masSizeType,"massiz")
      // console.log(this.state.rows,"mrow")

      // const hasDepartmentWithPOM = this.hasPermission1("customer", "deptwithpom", this.state.action, "web");
      // const hasDepartmentOnly = this.hasPermission1("customer", "deptonly", this.state.action, "web");
      // const hasPOMOnly = this.hasPermission1("customer", "pomonly", this.state.action, "web");
      
      // // Determine what to render
      // const showComp1 = hasDepartmentWithPOM || hasDepartmentOnly; // Comp1 for Department or Department with POM
      // const showComp2 = hasDepartmentWithPOM; // Comp2 only for Department with POM
      // const showComp3 = hasDepartmentWithPOM || hasDepartmentOnly || hasPOMOnly; // Comp3 for all cases


    // Filter garments to find the one matching the selected type
    const selectedGarment = Array.isArray(customer.pom) 
  ? customer.pom.find((pomItem) => pomItem.garmentType === selectedGarmentType) 
  : null;
  //console.log(this.state.action,"action")
  //console.log(this.state.customer,"customer")
  //console.log(this.state.action,"action")
  //console.log(row1,"row1")

    const assignModalContent = (
      <div class="row modal_override mb-0">
        <div class="col-md-12 text-center">
          <h6 className="text-color-green font-weight-bold pb-3">
            Assignment of process
          </h6>
        </div>
        {customer.departments 
        && customer.departments[this.state.deptIndex] 
        && customer.departments[this.state.deptIndex].assignmentOfWork && Object.keys(
          customer.departments[this.state.deptIndex].assignmentOfWork
        ).map((data, index) => {
          return (
            <AssigmentOfWork
              moduleName={[data]}
              assignmentOfWork={customer.departments[this.state.deptIndex].assignmentOfWork[data]}
              action={this.state.action}
              employeesOption={this.state.employeesOption}
              changeAssign={this.changeAssign}
              getAssign={this.getAssign}
              disabled={this.state.disabled}
              searchOption = {this.state.empOption1}
            />
          )
        })}
        {this.state.action !== "view" && <div className="col-md-12 text-center">
          <Button
            buttonName="save"
            onClick={this.onSave}
          />
        </div>}
      </div>
    )

    const trimPackModal = (
      <div class="row modal_override mb-0 p-3">
        <div class="col-md-12 text-center">
          <h6 className="text-color-green font-weight-bold pb-3">Trim Pack</h6>
        </div>
        {customer &&
        customer.departments &&
        customer.departments[this.state.deptIndex] &&
        customer.departments[this.state.deptIndex].trimPack &&
        customer.departments[this.state.deptIndex].trimPack.map(
          (data, trimPackIndex) => {
            return (
              <div className="col-md-12 br-col">
                <div className="col-md-12" key={trimPackIndex}>
                  <div
                    className={
                      this.state.action !== "view" ? "pull-right" : "d-none"
                    }
                  >
                    {!this.state.disabled && (
                      <Button
                        buttonType={trimPackIndex == 0 ? "add" : "remove"}
                        buttonName={trimPackIndex == 0 ? "add" : "remove"}
                        onClick={() => {
                          trimPackIndex == 0
                            ? this.addTrimPack(this.state.deptIndex)
                            : this.removeTrimPack(
                              this.state.deptIndex,
                              trimPackIndex
                            )
                        }}
                      />
                    )}
                  </div>
                  <div className="table">
                    <table className="table">
                      <thead>
                        <tr>
                          <th className="text-left" width="10%">
                            TRIM PACK No. {trimPackIndex + 1}
                          </th>
                          <th className="text-left" width="15%">
                            TYPE OF GMT
                          </th>
                          <th className="text-left" width="15%">
                            PACKAGING METHOD
                          </th>
                          <th className="text-left" width="15%">
                            PACKAGING TYPE
                          </th>
                          <th className="text-left" width="15%">
                            SUB TYPE
                          </th>
                          <th className="text-left" width="20%">
                            PACKAGING MATERIALS
                            {!this.state.disabled && (
                              <a
                                style={{ display: "inlineBlock" }}
                                className="btn-floating btn-small waves-effect waves-light green float-btn "
                                onClick={e =>
                                  this.addPackagingMaterial(trimPackIndex)
                                }
                              >
                                <i className="material-icons">add</i>
                              </a>
                            )}
                            {!this.state.disabled && (
                              <Picky
                                value={
                                  this.state.arrayOfPackagingMaterial &&
                                  this.state.arrayOfPackagingMaterial[
                                  this.state.deptIndex
                                  ] &&
                                  this.state.arrayOfPackagingMaterial[
                                  this.state.deptIndex
                                  ][trimPackIndex] || []
                                }
                                options={this.state.packagingMaterialsOption}
                                onChange={e =>
                                  this.selectMultipleOption(e, trimPackIndex)
                                }
                                open={false}
                                valueKey="id"
                                labelKey="name"
                                multiple={true}
                                includeSelectAll={true}
                                includeFilter={true}
                                dropdownHeight={600}
                                id={"trimPackPick" + trimPackIndex}
                              />
                            )}
                          </th>
                          <th className="text-left" width="10%">
                            COST
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td
                            className="text-left"
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "space-evenly"
                            }}
                          >
                            {data.trimPackNo}
                            <Field1
                              isFormGroup={false}
                              className={"pl-1"}
                              inputType={"radio"}
                              inputName={"default"}
                              value={"default" + trimPackIndex}
                              checked={data.default}
                              index={trimPackIndex}
                              onChange={(name, value) =>
                                this._handleInputChangeTrimPack(
                                  "default",
                                  value,
                                  trimPackIndex
                                )
                              }
                              disabled={this.state.disabled}
                            />
                          </td>
                          <td>
                            <Field1
                              isFormGroup={false}
                              inputType="select"
                              inputName="typeOfGmt"
                              value={data.typeOfGmt}
                              index={trimPackIndex}
                              options={this.state.typeOfGmtOption}
                              onChange={this._handleInputChangeTrimPack}
                              disabled={this.state.disabled}
                            />
                          </td>
                          <td>
                            <Field1
                              isFormGroup={false}
                              inputType="select"
                              inputName="packagingMethod"
                              value={data.packagingMethod}
                              index={trimPackIndex}
                              options={this.state.packagingMethodOption}
                              onChange={this._handleInputChangeTrimPack}
                              disabled={this.state.disabled}
                            />
                          </td>
                          <td>
                            <Field1
                              isFormGroup={false}
                              inputType="select"
                              inputName="packingType"
                              value={data.packingType}
                              index={trimPackIndex}
                              options={this.state.packingTypeOption}
                              onChange={this._handleInputChangeTrimPack}
                              disabled={this.state.disabled}
                            />
                          </td>
                          <td>
                            <Field1
                              isFormGroup={false}
                              inputType="select"
                              inputName="subType"
                              value={data.subType}
                              index={trimPackIndex}
                              options={
                                customer.departments[this.state.deptIndex]
                                  .trimPack[trimPackIndex].typeOfGmt !==
                                  undefined &&
                                  customer.departments[this.state.deptIndex]
                                    .trimPack[trimPackIndex].packagingMethod ===
                                  "BOXED" &&
                                  customer.departments[this.state.deptIndex]
                                    .trimPack[trimPackIndex].packingType ===
                                  "BDCM"
                                  ? [
                                    this.state.subTypeOption[0],
                                    this.state.subTypeOption[1]
                                  ]
                                  : customer.departments[this.state.deptIndex]
                                    .trimPack[trimPackIndex].typeOfGmt !==
                                    undefined &&
                                    customer.departments[this.state.deptIndex]
                                      .trimPack[trimPackIndex]
                                      .packagingMethod === "BOXED" &&
                                    customer.departments[this.state.deptIndex]
                                      .trimPack[trimPackIndex].packingType ===
                                    "REFURB"
                                    ? [
                                      this.state.subTypeOption[2],
                                      this.state.subTypeOption[3],
                                      this.state.subTypeOption[4]
                                    ]
                                    : this.state.subTypeOption
                              }
                              onChange={this._handleInputChangeTrimPack}
                              disabled={this.state.disabled}
                            />
                          </td>
                          {data.trimPackForm !== undefined &&
                            data.trimPackForm !== null &&
                            Object.keys(data.trimPackForm).length > 0 &&
                            Object.keys(data.trimPackForm).map(
                              (trimpackLabel, packIndex) => {
                                if (packIndex == 0) {
                                  return (
                                    <Fragment>
                                      <td>{trimpackLabel}</td>
                                      <td>
                                        <input
                                          className="form-control"
                                          type="number"
                                          name={trimpackLabel}
                                          value={
                                            data.trimPackForm[trimpackLabel] !==
                                              null
                                              ? data.trimPackForm[trimpackLabel]
                                              : ""
                                          }
                                          disabled={this.state.disabled}
                                          onChange={e =>
                                            this.state.action !== "view" &&
                                            this.handleChangePackaging(
                                              e.target.name,
                                              e.target.value,
                                              trimPackIndex
                                            )
                                          }
                                          onBlur={e =>
                                            this.updateCalcPackaging(
                                              trimPackIndex
                                            )
                                          }
                                        />
                                      </td>
                                      <td>
                                        {!this.state.disabled && (
                                          <ButtonIcon
                                            buttonType={"clear"}
                                            addRemoveFunc={() =>
                                              this.removeTrimPackForm(
                                                trimpackLabel,
                                                trimPackIndex
                                              )
                                            }
                                          />
                                        )}
                                      </td>
                                    </Fragment>
                                  )
                                }
                              }
                            )}
                        </tr>
                        {data.trimPackForm !== undefined &&
                          data.trimPackForm !== null &&
                          Object.keys(data.trimPackForm).length > 0 &&
                          Object.keys(data.trimPackForm).map(
                            (trimpackLabel, packIndex) => {
                              if (packIndex != 0) {
                                return (
                                  <tr key={packIndex}>
                                    <td colSpan={"5"} />
                                    <td>{trimpackLabel}</td>
                                    <td>
                                      <input
                                        className="form-control"
                                        type="number"
                                        name={trimpackLabel}
                                        value={
                                          data.trimPackForm[trimpackLabel] !==
                                            null
                                            ? data.trimPackForm[trimpackLabel]
                                            : ""
                                        }
                                        disabled={this.state.disabled}
                                        onChange={e =>
                                          this.state.action !== "view" &&
                                          this.handleChangePackaging(
                                            e.target.name,
                                            e.target.value,
                                            trimPackIndex
                                          )
                                        }
                                        onBlur={e =>
                                          this.updateCalcPackaging(
                                            trimPackIndex
                                          )
                                        }
                                      />
                                    </td>
                                    <td>
                                      {!this.state.disabled && (
                                        <ButtonIcon
                                          buttonType={"remove"}
                                          addRemoveFunc={() =>
                                            this.removeTrimPackForm(
                                              trimpackLabel,
                                              trimPackIndex
                                            )
                                          }
                                        />
                                      )}
                                    </td>
                                  </tr>
                                )
                              }
                            }
                          )}
                        <tr>
                          <td colSpan={"5"} />
                          <td className="text-left">
                            <label>TOTAL TRIM PACK COST: </label>
                          </td>
                          <td className="text-left">{data.totalAmount}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
               {/* <div className="col-md-12">
        <div className="col-md-12">
        <span className="inline-center">
              <label> packaging Materials </label>
              {this.state.action !== "view" && <a
                style={{ display: "block" }}
                className="btn-floating btn-small waves-effect waves-light green"
                onClick  = {() =>this.setState({ [`selectOpen${trimPackIndex}`] : true } )}
              >
                 <i className="material-icons">add</i>
              </a>}
          </span>
          <div className="col-md-2">
             { this.state[`selectOpen${trimPackIndex}`] && <select className="form-control" onChange={(e) => this.addPackagingMaterial(e.target.value,trimPackIndex)}>
                  <option value="">--select--</option>
                  {this.state.packagingMaterialsOption.map((trimpackLabel) => {
                   return <option value={trimpackLabel.label}>{trimpackLabel.label}</option>
                  })}
              </select>}
            </div>
          </div>
          <form id="trimpack">
            {data.trimPackForm !== undefined && data.trimPackForm !== null && Object.keys(data.trimPackForm).length > 0 &&  Object.keys(data.trimPackForm).map((trimpackLabel,packIndex) => {

              return <div className="col-md-3" key={packIndex}>
              <div className="form-group">
                <label >{trimpackLabel}</label>
                <input className="form-control" type="number" name={trimpackLabel}
                  value = {data.trimPackForm[trimpackLabel]}
                  onChange={(e) =>this.state.action !== "view" && this.handleChangePackaging(e.target.name,e.target.value,trimPackIndex)}
                  onBlur={(e) => this.updateCalcPackaging(trimPackIndex)}
                />
              </div>
              </div>
              ;
            })}
          </form>

          <div className="pull-right">
              <label>TOTAL TRIM PACK COST: </label><span>&nbsp; &nbsp; {data.totalAmount}</span>
          </div>
        </div> */}
                {/* <div className="pull-right">
              <label>TOTAL TRIM PACK COST: </label><span>&nbsp; &nbsp; {data.totalAmount}</span>
          </div> */}
              </div>
            )
          }
        )}
        {this.state.action !== "view" && <div className="col-md-12 text-center">
          <Button
            buttonName="save"
            onClick={this.onSave}
          />
        </div>}
      </div>
    )

    //pomList
    const pomList = []
    // customer.pom.map((data, index) => {
    //   pomList.push({
    //     name: this.getGarmentTypeLabel(data.garmentType) || "",
    //     key: index
    //   })
    // })

    // Check if customer and customer.pom exist and are arrays
    
    this.state.row1.map((data, index) => {
        pomList.push({
          name: this.getGarmentTypeLabel(data.garmentType) || "",
          key: index
        });
      });
    

    //departmentList
    const departmentList = []
    customer.departments.map((data, index) => {
      departmentList.push({
        name: data.departmentName,
        key: index
      })
    })

    return (
      <Fragment>
        {this.state.isLoading && <Loading />}
        <div className="right-section bg-white">
          <div className="container-fluid">
            {/* PAGE CONTENT START */}
            <div class="row m-0">
              {/* HEADING */}
              <div className="customer-wrap" style={{width:"100%"}}>
                {/* <PageHeader history={this.props.history} header={"Customer"} /> */}
                        {/* <div class="col-md-12 px-0 py-2 position-top-stick">
                            <div className="col-md-4 nopadding text-left">
                                {/* <span className="p-2 cursor-hover" onClick={(e) =>props.history.goBack()} > 
                                    <i className="fa fa-arrow-left"></i>
                                </span> *
                                <span className="p-2 cursor-hover" onClick={() => {
                                    const route = props.history.location.state && props.history.location.state.route
                                    route !== undefined ? props.history.push(`/${route}`, {
                                        [`${route.toLowerCase()}`]: {
                                            ...props.history.location.state[`${route.toLowerCase()}`]
                                        }
                                    }) : props.history.goBack()
                                }} >
                                    <img width={"20px"} src={leftArrowImage} />
                                </span>
                            </div>
                            <div className="col-md-4 nopadding text-center">
                                <h6>{props.header === "cad" ? "3D" : props.header}</h6>
                            </div>
                            <div className="col-md-4">
                            </div>
                        </div > */}
                        <div className="col-md-12 px-0 py-2 position-top-stick">
    <div className="col-md-4 nopadding text-left">
      <span className="p-2 cursor-hover" onClick={this.handleBackNavigation}>
        <img width={"20px"} src={leftArrowImage} alt="Back" />
      </span>
    </div>
    <div className="col-md-4 nopadding text-center">
      <h6>Customer</h6>
    </div>
    <div className="col-md-4"></div>
  </div>
                <Audit _id={this.state._id} />
                {/* FORM START */}
                <div class="col-md-12 mb-4">
                  <form action="" class="form-container">
                    {/* CUSTORM FIELD GROUP START*/}
                    
                    
                    <div class="row">
                      {/* Customer Name */}
                      <Field
                        inputname="customerName"
                        label="Customer Name"
                        inputType="text"
                        inputSizeClass="col-md-3"
                        value={customer.customerName}
                        onChange={this.onInputValChange}
                        readOnly={this.state.disabled}
                      />

                      {/* Customer Code */}
                      <Field
                        inputname="customerCode"
                        label="Customer Code"
                        inputType="text"
                        inputSizeClass="col-md-3"
                        value={customer.customerCode}
                        onChange={this.onInputValChange}
                        readOnly={this.state.disabled}
                      />
                      <Field
                        inputname="customerStatus"
                        label="Customer Status"
                        inputType="checkboxToggle"
                        inputSizeClass="col-md-3"
                        value={customer.customerStatus}
                        onChange={this.onInputValChange}
                        readOnly={this.state.disabled}
                      />
                    </div>
                    {/* CUSTORM FIELD GROUP END*/}
                    {/* ADDRESS FIELD GROUP START*/}
                    {(this.hasPermission1("customer", "withoutpoms", this.state.action, "web") || this.hasPermission1("customer","masterpom", this.state.action, "web")) && (
                    <Fragment>
                    <h6 className="fw-600 mb-3 text-left">Addresses</h6>
                    {customer.sites.map((data, i) => (
                      <div class="row p-r br-col">
                        {/* OFFICE NAME */}
                        <Field
                          inputname="officeName"
                          label="Office Name"
                          index={i}
                          inputType="select"
                          inputSizeClass="col-md-3"
                          options={this.state.officeOption}
                          value={customer.sites[i].officeName}
                          onChange={this.addressDynamicChange}
                          readOnly={this.state.disabled}
                        />
                        {/* CITY*/}
                        <Field
                          inputname="city"
                          label="City"
                          index={i}
                          inputType="select"
                          inputSizeClass="col-md-3"
                          options={this.state.cityOption}
                          value={customer.sites[i].city}
                          onChange={this.addressDynamicChange}
                          readOnly={this.state.disabled}
                        />
                        {/* ADDRESS 1 */}
                        <Field
                          inputname="registeredAddress1"
                          label="Registered Address 1"
                          inputType="text"
                          index={i}
                          inputSizeClass="col-md-6"
                          value={customer.sites[i].registeredAddress1}
                          onChange={this.addressDynamicChange}
                          readOnly={this.state.disabled}
                        />
                        {/* Country*/}
                        <Field
                          inputname="country"
                          label="Country"
                          inputType="select"
                          index={i}
                          inputSizeClass="col-md-3"
                          options={this.state.countryOption}
                          value={customer.sites[i].country}
                          onChange={this.addressDynamicChange}
                          readOnly={this.state.disabled}
                        />
                        {/* ADDRESS 2 */}
                        <Field
                          inputname="registeredAddress2"
                          label="Registered Address 2"
                          inputType="text"
                          index={i}
                          inputSizeClass="col-md-6"
                          value={customer.sites[i].registeredAddress2}
                          onChange={this.addressDynamicChange}
                          readOnly={this.state.disabled}
                        />
                        {/* ZIPCODE */}
                        <Field
                          inputname="zipCode"
                          label="ZIPCODE"
                          inputType="text"
                          index={i}
                          inputSizeClass="col-md-3"
                          value={customer.sites[i].zipCode}
                          onChange={this.addressDynamicChange}
                          readOnly={this.state.disabled}
                        />

                        <div className="Field-toggle-wrapper">
                          {/*DYNAMIC ADDD */}
                          {!this.state.disabled && i === 0 && (
                            <Button
                              buttonType="add"
                              onClick={e =>
                                this.dynamicAddCount(e, "addresses")
                              }
                            />
                          )}
                          {/*DYNAMIC REMOVE */}
                          {!this.state.disabled && i !== 0 && (
                            <Button
                              buttonType="remove"
                              onClick={e =>
                                this.dynamicRemoveCount(e, "addresses", i)
                              }
                            />
                          )}
                        </div>
                      </div>
                    ))}
                    {/* ADDRESS FIELD GROUP END*/}
                    {/* MISCELLANEOUS FIELD GROUP START*/}
                    <h6 className="fw-600 mb-3">Miscellaneous</h6>
                    <div className="row br-col">
                      {/* FIXED CHARGES*/}
                      <Field
                        inputname="fixedCharge"
                        label="Fixed Charges"
                        inputType="number"
                        inputSizeClass="col-md-3"
                        value={customer.fabricBasicRequirements.fixedCharge}
                        onChange={this.fabricDynamicChange}
                        readOnly={this.state.disabled}
                      />
                      {/* APPROVED TESTING LAB*/}
                      <Field
                        inputname="approvedTestingLab"
                        label="Approved Testing Lab"
                        inputType="select"
                        inputSizeClass="col-md-3"
                        options={this.state.approvedTestingLabOption}
                        value={
                          customer.fabricBasicRequirements.approvedTestingLab
                        }
                        onChange={this.fabricDynamicChange}
                        readOnly={this.state.disabled}
                      />
                      {/* PRIMARY LIGHT SOURCE*/}
                      <Field
                        inputname="primaryLightSource"
                        label="Primary Light Source"
                        inputType="select"
                        inputSizeClass="col-md-3"
                        options={this.state.lightSourceOption}
                        value={
                          customer.fabricBasicRequirements.primaryLightSource
                        }
                        onChange={this.fabricDynamicChange}
                        readOnly={this.state.disabled}
                      />
                      {/* ATTRIBUTES*/}
                      <Field
                        inputname="attribute"
                        label="Attribute"
                        inputType="select"
                        inputSizeClass="col-md-3"
                        options={this.state.attributesOption}
                        value={customer.fabricBasicRequirements.attribute}
                        onChange={this.fabricDynamicChange}
                        readOnly={this.state.disabled}
                      />

                      {/* SECONDARY LIGHT SOURCE*/}

                      <Field
                        inputname="secondaryLightSource"
                        label="Secondary Light Source"
                        inputType="select"
                        inputSizeClass="col-md-3"
                        options={this.state.lightSourceOption}
                        value={
                          customer.fabricBasicRequirements.secondaryLightSource
                        }
                        onChange={this.fabricDynamicChange}
                        readOnly={this.state.disabled}
                      />
                      {/* SECONDARY LIGHT SOURCE*/}
                    </div>
                    </Fragment>
                  )}
                    {/* MISCELLANEOUS FIELD GROUP END*/}
                    {(this.hasPermission1("customer", "garmentpom", this.state.action, "web") || this.hasPermission1("customer", "withoutpoms", this.state.action, "web")) && (
                     <React.Fragment>
                     <h6 className="fw-600 mb-3">Master POM</h6>
                     <div className="row br-col">
                     <div className= "container scrolle" style={{
                       maxHeight: "500px", 
                       overflowY: "auto", 
                       overflowX: "hidden", 
                     }}>
                     <div className="row mb-3">
                       <div className="col-md-2  pl-2"><label>Code</label></div>
                       <div className="col-md-7  pl-1"><label>Description</label></div>
                       {/* <div className="col-md-2  pl-1"><label>Shrinkage Type</label></div> */}
                       <div className="col-md-1">{rows.length === 0 && (
  <div className=" mt-3">
    <button
      type="button"
      className="btn green"
      style={{
        borderRadius: "50%",
        color: "white",
        width: "27px",
        height: "27px",
        padding: "0px",
      }}
      onClick={this.addRow}
      disabled={this.state.disabled}
    >
      <i className="material-icons" style={{ fontSize: "13px", fontWeight: "bold" }}>add</i>
    </button>
  </div>
)}</div>
                       <div className="col-md-1"></div>
                     </div>
                     {rows.map((row, index) => (
                       <div className="row mb-2" key={index}>
                         <div className="col-md-2" style={{paddingLeft:"0px",paddingRight:"25px"}}>
                         <input
                           className="w-100-f-12"
                           type="text"
                           name="code"
                           value={row.code}
                           onChange={(e) => {
                             const trimmedValue = this.preventLeadingSpaces(e.target.value);
                             this.handleRowChange("code", trimmedValue, index);
                           }}
                           readOnly={this.state.disabled}
                           maxLength={10}
                         />
 
                         </div>
                         <div className="col-md-7" style={{paddingLeft:"0px"}}>
                           {/* <Field
                             inputname="placeofMeasurement"
                             label=""
                             inputType="text"
                             value={row.placeofMeasurement}
                             inputSizeClass="description-width"
                             // onChange={(field, value) => this.handleRowChange("placeofMeasurement", value, index)}
                             onChange={(field, value) => {
                               const trimmedValue = this.preventLeadingSpaces(value);
                               this.handleRowChange("placeofMeasurement", trimmedValue, index);
                             }}
                             readOnly={this.state.disabled}
                             maxLength={45}
                           /> */}
                           {/* <textarea
                              name="placeofMeasurement"
                              className="w-100-f-12"
                              value={row.placeofMeasurement}
                              onChange={(e) => {
                                const trimmedValue = this.preventLeadingSpaces(e.target.value);
                                this.handleRowChange("placeofMeasurement", trimmedValue, index);
                              }}
                              onInput={(e) => {
                                e.target.style.height = "auto"; // Reset height to recalculate
                                e.target.style.height = `${e.target.scrollHeight}px`; // Set height based on content
                              }}
                              readOnly={this.state.disabled}
                               maxLength={150}
                              rows="1" // Ensures it spans two rows
                              style={{ overflow: "hidden", resize: "none" }}
                            /> */}

<textarea
  ref={(el) => {
    if (el) {
      el.style.height = "auto"; // Reset height first
      if (el.scrollHeight > el.clientHeight) {
        el.style.height = `${el.scrollHeight}px`; // Expand only if needed
      }
    }
  }}
  name="placeofMeasurement"
  className="w-100-f-12"
  value={row.placeofMeasurement}
  onChange={(e) => {
    
   this.handleRowChange("placeofMeasurement", e.target.value, index);

    // Auto-expand only when needed
    e.target.style.height = "auto";
    if (e.target.scrollHeight > e.target.clientHeight) {
      e.target.style.height = `${e.target.scrollHeight}px`;
    }
  }}
  onBlur = {(e) => {
    const trimmedValue = this.preventLeadingSpaces(e.target.value);
    const pascalCaseValue = trimmedValue
      .toLowerCase()
      .replace(/\s+/g, " ")
      .split(" ")
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  
    this.handleRowChange("placeofMeasurement", pascalCaseValue, index);
  }}
  readOnly={this.state.disabled}
  maxLength={150}
  rows="1"
  style={{ overflow: "hidden", resize: "none" }}
/>

 
                         </div>
                         {/* <div className="col-md-2" style={{paddingLeft:"0px"}}> */}
                           {/* <Field
                             inputname="shrinkageType"
                             label=""
                             inputType="select"
                             options={this.state.SHRINKAGETYPEOPTIONS}
                             value={row.shrinkageType}
                             onChange={(field, value) => this.handleRowChange("shrinkageType", value, index)}
                             readOnly={this.state.disabled}
                           /> */}
                           {/* <select
                           style={{width:"60%"}}
                           className="w-100-f-12"
                           name="shrinkageType"
                           value={row.shrinkageType}
                           onChange={(e) => this.handleRowChange("shrinkageType", e.target.value, index)}
                           disabled={this.state.disabled}
                         >
                           {this.state.SHRINKAGETYPEOPTIONS.map((option, idx) => (
                             <option key={idx} value={option.value}>
                               {option.label}
                             </option>
                           ))}
                         </select>
 
                         </div> */}
                         <div className="col-md-1 text-center flex-jcenter-acenter">
                           <button
                             className="btn"
                             style={{backgroundColor:"#F443361A",color:"#F44336",borderRadius:"50%",width:"25px",height:"25px",padding:"0px",margin:"0px"}}
                             type="button"
                             onClick={() => this.deleteRow(index)}
                             disabled={this.state.disabled}
                           >
                             {/* ✖ */}
                             <i className="material-icons" style={{fontSize:"13px", fontWeight:"bold"}}>clear</i>
                           </button>


                           </div>
                          <div className="col-md-1 text-center flex-jcenter-acenter" style={{justifyContent:"start",padding:"0px",marginLeft:"-17px"}}>
                           {/* Add Button (Only on the Last Row) */}
      {index === rows.length - 1 && (
        <button type="button" className="btn green" style={{borderRadius:"50%",color:"white",width:"27px",height:"27px",padding:"0px",marginRight:"16px"}} onClick={this.addRow} disabled={this.state.disabled}>
        {/* ➕ */}
        <i className="material-icons" style={{fontSize:"13px", fontWeight:"bold"}}>add</i>
      </button>
      )}
                         </div>
                       </div>
                     ))}
                    
                     {/* <div className="row" style={{marginBottom:"0px"}}>
                       <div className="col-md-10 text-right mt-10">
                         <button type="button" className="btn green" style={{borderRadius:"50%",color:"white",width:"30px",height:"30px",padding:"0px",marginRight:"16px"}} onClick={this.addRow} disabled={this.state.disabled}>
                           {/* ➕ 
                           <i className="material-icons" style={{fontSize:"13px", fontWeight:"bold"}}>add</i>
                         </button>
                       </div>
                       </div> */}
 
                     </div>
                     <div className="col-md-12 p-0 text-center">
                       <Button
                         buttonName={"save"}
                         buttonType={"save"}
                         onClick={this.onPomSave}
                         disabled={this.state.disabled || this.state._id === ""}
                       />
                       {/* <Button
                         buttonName={"cancel"}
                         buttonType={"cancel"}
                         history={this.props.history}
                       /> */}
                     </div>
                   </div>
                   </React.Fragment>
                  )}
                  { (this.hasPermission1("customer", "garmentpom", this.state.action, "web") || this.hasPermission1("customer", "withoutpoms", this.state.action, "web")) && (
                    <React.Fragment>
                  <h6 class="fw-600 py-3"> Garment POM</h6>
                    <div class="col-md-12 p-0 mb-3">
                      <div class="upload-container br-col p-r">
                        <ul class="list-inline mb-0 mt-2 ml-2">
                          {pomList.map((data, co) => {
                            return (
                              data.name != "" && (
                                <li>
                                  <div class="card card-design">
                                    <a
                                      className="primary-text" href="javascript:;"
                                      onClick={() => this.scrollToModule(`pom${co}`, co)}
                                    >
                                      {data.name}
                                    </a>
                                  </div>
                                </li>
                              )
                            )
                          })}
                        </ul>
                      </div>
                    </div>
                    {/* {customer.garmentDetails && Array.isArray(customer.garmentDetails) && customer.garmentDetails.length > 0 && customer.garmentDetails.map((data, i) => {
                       */}
                       {row1.map((data, i) => {
  const isToggled = this.state.toggleState[i] || false;
  const isTableToggled = this.state.tableToggleState[i] || false;
  const filteredRows = this.getFilteredData(data.sizeTypeDetails, this.state.searchInput[i]);
  // const searchQuery = this.state.searchQueries && this.state.searchQueries[i] || ""; // Track search query for each row

  // const filteredData = data.sizeTypeDetails
  //   ? data.sizeTypeDetails.filter(
  //       (option) =>
  //         option.code.toLowerCase().includes(searchQuery.toLowerCase()) ||
  //         option.placeofMeasurement.toLowerCase().includes(searchQuery.toLowerCase())
  //     )
  //   : [];

  return (
    <div className="col-md-12 p-0 mb-5" id={`pom${i}`} key={`pom${i}`}>
      <div className="upload-container br-col p-r p-0">
        <div className="inline-center nopadding">
          {isToggled ? (
            <span onClick={() => this.handleToggle(i)}>
              <i className="fa fa-angle-up font-icon" />
            </span>
          ) : (
            <span onClick={() => this.handleToggle(i)}>
              <i className="fa fa-angle-down font-icon" />
            </span>
          )}
        </div>
        <div className="row p-4">
          <Field
            inputname="garmentType"
            label="Garment Type"
            inputType="select"
            options={this.state.GARMENTTYPEOPTIONS}
            inputSizeClass="col-md-3"
            value={data.garmentType || ""}
            onChange={(field, value) => this.handlePomChange("garmentType", value, i)}
            readOnly={this.state.disabled}
          />
          {isToggled &&data.garmentType && (
            <Fragment>
              <div className="col-md-12 p-0">
                <div className="row align-items-center" style={{marginLeft:"68px"}}>
                  <div className="col-md-auto label-standard-w">
                    <h6 className="fw-600 py-3 ">
                    {`${this.getGarmentTypeLabel(data.garmentType)} POM` || ""}
                    </h6>
                    <div key={i} className="toggle-container">
            {/* Toggle Box */}
            {/* <div
              className="toggle-box"
              onClick={() => this.tableToggle(i)}
              style={{
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "center",
                border: "1px solid #ddd",
                padding: "10px",
                cursor: "pointer",
                marginBottom:"21px",
                width:"1100px"
              }}
            >
              <i
                className={`fa ${
                  isTableToggled ? "fa fa-angle-up" : "fa fa-angle-down"
                } `}
              />
            </div> */}
            <div
  className="toggle-box"
  onClick={() => this.tableToggle(i)}
  style={{
    display: "flex",
    justifyContent: "space-between",  // Spread items
    alignItems: "center",
    border: "1px solid #ddd",
    padding: "10px",
    cursor: "pointer",
    marginBottom: "21px",
    width: "1100px",
    backgroundColor: "#f9f9f9", // Light background for clarity
  }}
>
  {/* Search Box Inside Toggle Box */}
  <div style={{ flex: 1, position: "relative", marginRight: "10px" }}>
    <input
      type="text"
      className="form-control"
      placeholder="Search Code or Measurement"
      value={(this.state.searchInput && this.state.searchInput[i]) || ""}
      onChange={(e) => this.handleSearchChange(e.target.value, i)}
      onClick={(e) => e.stopPropagation()}  // Prevents toggle when clicking input
      style={{
        width: "100%",
        paddingRight: "30px",
        padding: "5px 10px",
        borderRadius: "4px",
        border: "1px solid #ccc",
      }}
    />
    {this.state.searchInput[i] && (
      <i
        className="fa fa-times"
        onClick={(e) => {
          e.stopPropagation(); // Prevents accidental toggle when clearing
          this.clearSearch(i);
        }}
        style={{
          position: "absolute",
          right: "10px",
          top: "50%",
          transform: "translateY(-50%)",
          cursor: "pointer",
          color: "#777",
        }}
      />
    )}
  </div>

  {/* Toggle Icon */}
  <i
    className={`fa ${isTableToggled ? "fa-angle-up" : "fa-angle-down"}`}
    style={{ fontSize: "16px", marginLeft: "10px" }}
  />
</div>
            {(data.garmentType || isTableToggled) && isTableToggled && (
              <Fragment>
                <div className="scrolle" style={{minHeight:"100px",maxHeight:"272px",overflow :"auto", border:"1px solid #dddddd",borderRadius:"14px",padding:"4px"}}>
                {data.sizeTypeDetails && data.sizeTypeDetails.length > 0 ? (
                  <table className="border-0" style={{marginBottom:"40px", width:"auto",}}>
                      <thead className="border-0">
                        <tr>
                          <th>
                            <input
                              type="checkbox"
                              style={{
                                position: "static",
                                left: "auto",
                                opacity: 1,
                                display: "inline-block",
                              }}
                              // checked={this.state.action !== "add" &&
                              //   data.sizeTypeDetails.length === rows.length}
                              // onChange={() => this.handleSelectAll(i, data.sizeTypeDetails)}
                              // disabled={this.state.disabled}
                              onChange={() => this.handleSelectAll(i, data.sizeTypeDetails)}
                              disabled={this.state.disabled}
                              // checked={(this.state.selectedRows[i] || []).length === data.sizeTypeDetails.length}
                              checked={data.sizeTypeDetails.length > 0 &&  // Ensure there are rows to select
                                (this.state.selectedRows[i] || []).length === data.sizeTypeDetails.length &&
                                data.sizeTypeDetails.length !== 0   // Ensure both aren't 0
                                }
                            />
                          </th>
                          <th style={{padding:"10px",}}>Code</th>
                          <th style={{padding:"10px",textAlign:"left"}}>Place of Measurement</th>
                          {/* <th style={{padding:"10px",}}>Shrinkage Type</th> */}
                        </tr>
                      </thead>
                      <tbody>
                        
                        {/* {data.sizeTypeDetails.map((option, index) => ( */}
                        {/* {this.getFilteredData(data.sizeTypeDetails, this.state.searchInput[i]).map((option, index) => { */}
                        {filteredRows.map((option, index) => {
                          //console.log(data.sizeTypeDetails,"sizetypede")
                          //console.log(option,"opt");
                          //console.log(option.code,"co")
                          //console.log(option.placeofMeasurement,"pac")
                          return(
                          
                          <tr>
                            <td>
                              
                               <input
                               style={{
                                position: "static",
                                left: "auto",
                                opacity: 1,
                                display: "inline-block",
                              }}
                              type="checkbox"
                              // checked={(this.state.selectedRows[data._id] || []).includes(option._id)}
                              // onChange={(e) => this.handleRowSelect(
                              //   data._id, 
                              //   option._id, 
                              //   e.target.checked
                              // )}
                              checked={(this.state.selectedRows[i] || []).includes(option._id)} // ✅ Use index instead of garmentId
                              onChange={(e) => this.handleRowSelect(i, option._id, e.target.checked)} // ✅ Pass index
                              disabled={this.state.disabled}
                              />
                            </td>
                            <td style={{fontSize:"12px"}}>{option.code}</td>
                            <td style={{textAlign:"left",fontSize:"12px"}}>{option.placeofMeasurement}</td>
                            {/* <td style={{}}>{this.renderShrinkageTypeLabel(option.shrinkageType)}</td> */}
                          </tr>
                        )})}
                      </tbody>
                    </table>
                ):(<span>loading...</span>)}
                </div>
                    
                    {((data.sizeTypeDetails && data.sizeTypeDetails.length > 0) || (data.length > 0)) && (
      <div className="second-table">
        <h6 style={{ marginBottom: "20px",marginTop:"15px" }}>
          Selected {this.getGarmentTypeLabel(data.garmentType)} POM
        </h6>
        <div className="scrolle" style={{minHeight:"100px",maxHeight:"272px",overflow :"auto",border:"1px solid #dddddd",borderRadius:"14px",padding:"4px"}}>
        {data.sizeTypeDetails && data.sizeTypeDetails.length > 0 ? (
        <table className="border-0" style={{width:"auto"}}>
          <thead className="border-0">
            <tr>
              <th><input type="checkbox" name="" id="" style={{visibility:"hidden", position: "static",left: "auto", display: "inline-block",}} /></th>
              <th style={{padding:"10px",}}>Code</th>
              <th style={{padding:"10px",textAlign:"left"}}>Place of Measurement</th>
              {/* <th style={{padding:"10px",}}>Shrinkage Type</th> */}
            </tr>
          </thead>
          <tbody>
            {/* Filter the selected options based on selectedRows */}
            {data.sizeTypeDetails
              .filter(option =>
                (this.state.selectedRows[i] || []).includes(option._id)
              )
              .map(option => (
                <tr key={option._id}>
                  <td> <input type="checkbox" name="" id="" style={{visibility:"hidden", position: "static",left: "auto", display: "inline-block",}} /></td>
                  <td style={{fontSize:"12px"}}>{option.code}</td>
                  <td style={{textAlign:"left",fontSize:"12px"}}>{option.placeofMeasurement}</td>
                  {/* <td style={{}}>{this.renderShrinkageTypeLabel(option.shrinkageType)}</td> */}
                </tr>
              ))}
          </tbody>
        </table>
         ):(<span>loading...</span>)}
        </div>
        <div className="flex-center-mtb-15"> <button className="primary" onClick={(e) => this.seperateGarmentPomSave(e, i)}>save</button></div>
        
      </div>
    )}
                    {/* {((data.sizeTypeDetails && data.sizeTypeDetails.length > 0) || (data.length > 0)) && (
                      <div className="second-table">
                        <h6 style={{marginBottom:"20px"}}>Selected {this.getGarmentTypeLabel(data.garmentType)} POM</h6>
                        <table className="border-0">
                          <thead className="border-0">
                            <tr>
                              <th style={{padding:"7px"}}>Code</th>
                              <th>Place of Measurement</th>
                              <th>Shrinkage Type</th>
                            </tr>
                          </thead>
                          <tbody>
                           
                              {row1
                              .filter(option => 
                                (this.state.selectedRows[data._id] || []).includes(option._id)
                              )
                              .map(option => (
                                <tr key={option._id}>
                                  <td>{option.code}</td>
                                  <td>{option.placeofMeasurement}</td>
                                  <td>{this.renderShrinkageTypeLabel(option.shrinkageType)}</td>
                                </tr>
                              ))}
                          </tbody>
                        </table>
                      </div>
                    )} */}
              </Fragment>
            )}

                  </div>
                    
                  </div>
                </div>
              </div>
            </Fragment>
          )}
        </div>
        <div className="Field-toggle-wrapper">
                              {/* DYNAMIC ADD */}
                              {!this.state.disabled && i === 0 && (
                                <Button
                                  buttonType="add"
                                  onClick={e =>
                                    this.dynamicAddCount(e, "pom")
                                  }
                                />
                              )}
                              {/* DYNAMIC REMOVE */}
                              {!this.state.disabled && i !== 0 && (
                                <Button
                                  buttonType="remove"
                                  onClick={() => this.garmentPomDelete1(i)
                                  }
                                />
                              )}
                            </div>
      </div>
    </div>
  );
})}
</React.Fragment>
)}



                    


                    {/* UPLOADED FILE START */}
                    {(this.hasPermission1("customer","withoutpoms", this.state.action, "web") || this.hasPermission1("customer","masterpom", this.state.action, "web")) && (
                    <Fragment>
                    <h6 class="fw-600 py-3">Fabric spec</h6>
                    <div class="col-md-12 no-padding mb-3">
                      <FileUpload
                        Heading="Upload Images"
                        getRefImages={this.getRefImages}
                        moduleName={"customer"}
                        disabled={this.state.disabled}
                        uploadedDocs={
                          customer.refImages.length > 0
                            ? customer.refImages
                            : null
                        }
                        imageTypeOption={this.state.imageTypeOption}
                      />
                    </div>

                    {/* UPLOADED FILE END */}
                    <h6 class="fw-600 py-3"> Departments</h6>
                    <div class="col-md-12 p-0 mb-3">
                      <div class="upload-container br-col p-r">
                        <ul class="list-inline mb-0 mt-2 ml-2">
                          {departmentList.map((data, co) => {
                            return (
                              data.name != "" && (
                                <li>
                                  <div class="card card-design">
                                    <a
                                      className="primary-text" href="javascript:;"
                                      onClick={() => this.scrollToModule(`dept${co}`)}
                                    >
                                      {data.name}
                                    </a>
                                  </div>
                                </li>
                              )
                            )
                          })}
                        </ul>
                      </div>
                    </div>
                    </Fragment>
                    )}
                    {(this.hasPermission1("customer", "withoutpoms", this.state.action, "web") || this.hasPermission1("customer","masterpom", this.state.action, "web")) && (
                    <Fragment>
                    {customer.departments.map((data, i) => {
                      return (
                        <div class="col-md-12 p-0 mb-5" id={`dept${i}`}>
                          <div class="upload-container br-col p-r p-0">
                            <div className="inline-center nopadding">
                              {data.toggle ? (
                                <span onClick={() => this.changeToggleList(i)}>
                                  <i className="fa fa-angle-up font-icon " />
                                </span>
                              ) : (
                                  <span onClick={() => this.changeToggleList(i)}>
                                    <i className="fa fa-angle-down font-icon " />
                                  </span>
                                )}
                            </div>
                            <div className="row p-4">
                              {/* FIELD:NAME OF DEPARTMENT */}
                              <Field
                                inputname="departmentName"
                                label="Name of the Dept"
                                inputType="text"
                                options={[]}
                                index={i}
                                inputSizeClass="col-md-3"
                                value={data.departmentName}
                                onChange={this.departmentDynamicChange}
                                readOnly={this.state.disabled}
                              />
                              {/* FIELD: CONTROLLER */}
                              {!data.toggle && (
                                <Fragment>
                                  <div class="col-md-6 p-0">
                                    <div class="row align-items-center">
                                      <div class="col-md-auto label-standard-w">
                                        <label for="">{"Controller"}</label>
                                      </div>
                                      <div
                                        class={["p-0", "col-md-3"].join(" ")}
                                      >
                                        <div className="custom-async-select">
                                          <AsyncSelect
                                            name="controller"
                                            // value={data.controller}
                                            value={this.state.empOption1 && this.state.empOption1.find(option => option.value === data.controller)||null}
                                            onFocus={() => this.getAssign("")}
                                            onInputChange={this.getAssign}
                                            onChange={val =>
                                              this.updateAsyncValues(
                                                val,
                                                "controller",
                                                i
                                              )
                                            }
                                            placeholder="Find Controller"
                                            options={employeesOption}
                                            disabled={this.state.disabled}
                                            isClearable
                                            clearValue={this.clearValue}
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="col-md-12 p-0">
                                    <div class="row align-items-center">
                                      <div class="col-md-auto label-standard-w">
                                        <label for="">{"All sizes"}</label>
                                      </div>
                                      <div
                                        class={[
                                          "p-0",
                                          "col-md-9 dis-flex",
                                          "flex-wrap"
                                        ].join(" ")}
                                      >
                                        {data.allSizes.map(
                                          (size, allsizeInd) => {
                                            return (
                                              <div class="dis-flex">
                                                <input
                                                  type="text"
                                                  className="form-control"
                                                  style={{
                                                    width: "50px"
                                                  }}
                                                  value={size.size}
                                                  disabled={this.state.disabled}
                                                  onChange={e =>
                                                    this.allSizesDynamicChange(
                                                      "size",
                                                      e.target.value,
                                                      i,
                                                      allsizeInd
                                                    )
                                                  }
                                                />
                                                <select
                                                  style={{
                                                    width: "70px"
                                                  }}
                                                  className="form-control ml-1"
                                                  value={size.period}
                                                  disabled={this.state.disabled}
                                                  onChange={e =>
                                                    this.allSizesDynamicChange(
                                                      "period",
                                                      e.target.value,
                                                      i,
                                                      allsizeInd
                                                    )
                                                  }
                                                >
                                                  <option value="">--</option>
                                                  <option value="year">
                                                    year
                                                  </option>
                                                  <option value="month">
                                                    month
                                                  </option>
                                                </select>
                                                <div className="ml-1">
                                                  {!this.state.disabled && (
                                                    <ButtonIcon
                                                      buttonType={
                                                        allsizeInd == 0
                                                          ? "add"
                                                          : "remove"
                                                      }
                                                      addRemoveFunc={() => {
                                                        allsizeInd == 0
                                                          ? this.addAllSizes(i)
                                                          : this.removeAllSizes(
                                                            i,
                                                            allsizeInd
                                                          )
                                                      }}
                                                    />
                                                  )}
                                                </div>
                                              </div>
                                            )
                                          }
                                        )}
                                      </div>
                                    </div>
                                  </div>

                                  {/* FIELD: PRICE QUOTE METHOD */}
                                  <Field
                                    inputname="priceQuoteMethod"
                                    label="Price Quote Method"
                                    inputType="select"
                                    inputSizeClass="col-md-3"
                                    index={i}
                                    options={[
                                      {
                                        label: "MULTIPLE",
                                        value: "MULTIPLE"
                                      },
                                      {
                                        label: "SINGLE",
                                        value: "SINGLE"
                                      }
                                    ]}
                                    value={data.priceQuoteMethod}
                                    onChange={this.departmentDynamicChange}
                                    readOnly={this.state.disabled}
                                  />

                                  {/* FIELD: SENIOR MERCHANDISER */}
                                  <div class="col-md-6 p-0">
                                    <div class="row align-items-center">
                                      <div class="col-md-auto label-standard-w">
                                        <label for="">
                                          {"Senior Merchandiser"}
                                        </label>
                                      </div>
                                      <div
                                        class={["p-0", "col-md-3"].join(" ")}
                                      >
                                        <div className="custom-async-select">
                                          <AsyncSelect
                                            name="seniorMerchandiser"
                                            // value={data.seniorMerchandiser}
                                            value={this.state.empOption1 && this.state.empOption1.find(option => option.value === data.seniorMerchandiser)||null}
                                            onFocus={() => this.getAssign("")}
                                            onInputChange={this.getAssign}
                                            onChange={val =>
                                              this.updateAsyncValues(
                                                val,
                                                "seniorMerchandiser",
                                                i
                                              )
                                            }
                                            placeholder="Find SeniorMerchandiser"
                                            options={employeesOption}
                                            disabled={this.state.disabled}
                                            isClearable
                                            clearValue={this.clearValue}
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </div>

                                  <div class="col-md-6 p-0">
                                    <div class="row align-items-center">
                                      <div class="col-md-auto label-standard-w">
                                        <label for="">{"Range"}</label>
                                      </div>
                                      <div
                                        class={["p-0", "col-md-6"].join(" ")}
                                      >
                                        <Picky
                                          value={data.range}
                                          options={rangeOption}
                                          onChange={val =>
                                            this.departmentDynamicChange(
                                              "range",
                                              val,
                                              i
                                            )
                                          }
                                          open={false}
                                          valueKey="value"
                                          labelKey="label"
                                          multiple={true}
                                          includeSelectAll={true}
                                          includeFilter={true}
                                          dropdownHeight={300}
                                          disabled={this.state.disabled}
                                        />
                                      </div>
                                    </div>
                                  </div>

                                  {/* FIELD: MERCHANDISER */}
                                  <div class="col-md-6 p-0">
                                    <div class="row align-items-center">
                                      <div class="col-md-auto label-standard-w">
                                        <label for="">{"Merchandiser"}</label>
                                      </div>
                                      <div
                                        class={["p-0", "col-md-3"].join(" ")}
                                      >
                                        <div className="custom-async-select">
                                          <AsyncSelect
                                            name="merchandiser"
                                            // value={data.merchandiser}
                                            value={this.state.empOption1 && this.state.empOption1.find(option => option.value === data.merchandiser)||null}
                                            onFocus={() => this.getAssign("")}
                                            onInputChange={this.getAssign}
                                            onChange={val =>
                                              this.updateAsyncValues(
                                                val,
                                                "merchandiser",
                                                i
                                              )
                                            }
                                            placeholder="Find Merchandiser"
                                            options={employeesOption}
                                            disabled={this.state.disabled}
                                            isClearable
                                            clearValue={this.clearValue}
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  {/* FIELD: TRIM PACK */}
                                  <div class="col-md-6 p-0">
                                    <div class="row align-items-center">
                                      <div class="col-md-auto label-standard-w">
                                        <label for="">Trim Pack</label>
                                      </div>
                                      <div class="p-0 col-md-3">
                                        <button
                                          class="primary-small"
                                          type="button"
                                          onClick={e => {
                                            this.setState(
                                              {
                                                deptIndex: i
                                              },
                                              () =>
                                                this.setState({
                                                  openModal: true,
                                                  modalType: "trimpack"
                                                })
                                            )
                                          }}
                                        >
                                          Trim pack
                                        </button>
                                      </div>
                                    </div>
                                  </div>

                                  {/* FIELD: JUNIOR MERCHANDISER */}
                                  <div class="col-md-6 p-0">
                                    <div class="row align-items-center">
                                      <div class="col-md-auto label-standard-w">
                                        <label for="">
                                          {"Junior Merchandiser"}
                                        </label>
                                      </div>
                                      <div
                                        class={["p-0", "col-md-3"].join(" ")}
                                      >
                                        <div className="custom-async-select">
                                          <AsyncSelect
                                            name="juniorMerchandiser"
                                            // value={data.juniorMerchandiser}
                                            value={this.state.empOption1 && this.state.empOption1.find(option => option.value === data.juniorMerchandiser)||null}
                                            onFocus={() => this.getAssign("")}
                                            onInputChange={this.getAssign}
                                            onChange={val =>
                                              this.updateAsyncValues(
                                                val,
                                                "juniorMerchandiser",
                                                i
                                              )
                                            }
                                            placeholder="Find Junior Merchandiser"
                                            options={employeesOption}
                                            disabled={this.state.disabled}
                                            isClearable
                                            clearValue={this.clearValue}
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </div>

                                  {/* FIELD: ASSIGNMENT OF PROCESSES*/}
                                  <div class="col-md-6 p-0">
                                    <div class="row align-items-center">
                                      <div class="col-md-auto label-standard-w">
                                        <label for="">
                                          Assignment Of Process
                                        </label>
                                      </div>
                                      <div class="p-0 col-md-4">
                                        <button
                                          class="primary-small"
                                          type="button"
                                          onClick={e => {
                                            this.setState(
                                              {
                                                deptIndex: i
                                              },
                                              () =>
                                                this.setState({
                                                  openModal: true,
                                                  modalType: "assign"
                                                })
                                            )
                                          }}
                                        >
                                          Assigment of process
                                        </button>
                                      </div>
                                    </div>
                                  </div>

                                  {/* FIELD: MAGNUM GARMENT TECHNOLOGIST*/}
                                  <div class="col-md-6 p-0">
                                    <div class="row align-items-center">
                                      <div class="col-md-auto label-standard-w">
                                        <label for="">
                                          {"Magnum Garment Technologist"}
                                        </label>
                                      </div>
                                      <div
                                        class={["p-0", "col-md-3"].join(" ")}
                                      >
                                        <div className="custom-async-select">
                                          <AsyncSelect
                                            name="garmentTechnologist"
                                            // value={data.garmentTechnologist}
                                            value={this.state.empOption1 && this.state.empOption1.find(option => option.value === data.garmentTechnologist)||null}
                                            onInputChange={this.getAssign}
                                            onChange={val =>
                                              this.updateAsyncValues(
                                                val,
                                                "garmentTechnologist",
                                                i
                                              )
                                            }
                                            placeholder="Find Magnum Garment Technologist"
                                            options={employeesOption}
                                            disabled={this.state.disabled}
                                            isClearable
                                            clearValue={this.clearValue}
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </div>

                                  {/* FIELD: price quote size */}
                                  <div class="col-md-12 p-0">
                                    <div class="row align-items-center">
                                      <div class="col-md-auto label-standard-w">
                                        <label for="">
                                          {"Price Quote Size"}
                                        </label>
                                      </div>
                                      <div
                                        class={["p-0", "col-md-3"].join(" ")}
                                      >
                                        <div className="col-md-12">
                                          {data.priceQuoteMethod ==
                                            "MULTIPLE" &&
                                            data.priceQuotesizeMultiple.map(
                                              (priceSize, priceInd) => {
                                                return (
                                                  <div class="dis-flex">
                                                    <div>
                                                      <input
                                                        type="text"
                                                        className="form-control"
                                                        style={{
                                                          width: "50px"
                                                        }}
                                                        value={priceSize.start}
                                                        disabled={
                                                          this.state.disabled
                                                        }
                                                        onChange={e =>
                                                          this.priceQuoteSizeMultiDynamicChange(
                                                            "start",
                                                            e.target.value,
                                                            i,
                                                            priceInd
                                                          )
                                                        }
                                                      />
                                                    </div>
                                                    <div className="px-1">
                                                      {" "}
                                                      {"-"}
                                                    </div>
                                                    <div>
                                                      <input
                                                        type="text"
                                                        className="form-control"
                                                        style={{
                                                          width: "50px"
                                                        }}
                                                        value={priceSize.end}
                                                        disabled={
                                                          this.state.disabled
                                                        }
                                                        onChange={e =>
                                                          this.priceQuoteSizeMultiDynamicChange(
                                                            "end",
                                                            e.target.value,
                                                            i,
                                                            priceInd
                                                          )
                                                        }
                                                      />
                                                    </div>

                                                    <div class="ml-2">
                                                      <select
                                                        style={{
                                                          width: "70px"
                                                        }}
                                                        className="form-control"
                                                        value={priceSize.period}
                                                        disabled={
                                                          this.state.disabled
                                                        }
                                                        onChange={e =>
                                                          this.priceQuoteSizeMultiDynamicChange(
                                                            "period",
                                                            e.target.value,
                                                            i,
                                                            priceInd
                                                          )
                                                        }
                                                      >
                                                        <option value="">
                                                          --
                                                        </option>
                                                        <option value="year">
                                                          year
                                                        </option>
                                                        <option value="month">
                                                          month
                                                        </option>
                                                      </select>
                                                    </div>
                                                    <div class="ml-2">
                                                      {!this.state.disabled && (
                                                        <ButtonIcon
                                                          buttonType={
                                                            priceInd == 0
                                                              ? "add"
                                                              : "remove"
                                                          }
                                                          addRemoveFunc={() => {
                                                            priceInd == 0
                                                              ? this.addPriceQuoteSizeMulti(
                                                                i
                                                              )
                                                              : this.removePriceQuoteSizeMulti(
                                                                i,
                                                                priceInd
                                                              )
                                                          }}
                                                        />
                                                      )}
                                                    </div>
                                                  </div>
                                                )
                                              }
                                            )}

                                          {data.priceQuoteMethod == "SINGLE" &&
                                            data.priceQuotesizeSingle.map(
                                              (priceSize, priceInd) => (
                                                <div class="dis-flex">
                                                  <div>
                                                    <input
                                                      type="text"
                                                      className="form-control"
                                                      style={{
                                                        width: "50px"
                                                      }}
                                                      value={priceSize.size}
                                                      disabled={
                                                        this.state.disabled
                                                      }
                                                      onChange={e =>
                                                        this.updatePriceQuoteSizeSingle(
                                                          "size",
                                                          e.target.value,
                                                          i,
                                                          priceInd
                                                        )
                                                      }
                                                    />
                                                  </div>
                                                  <div class="ml-2">
                                                    <select
                                                      style={{
                                                        width: "70px"
                                                      }}
                                                      className="form-control"
                                                      disabled={
                                                        this.state.disabled
                                                      }
                                                      value={priceSize.period}
                                                      onChange={e =>
                                                        this.updatePriceQuoteSizeSingle(
                                                          "period",
                                                          e.target.value,
                                                          i,
                                                          priceInd
                                                        )
                                                      }
                                                    >
                                                      <option value="">
                                                        --
                                                      </option>
                                                      <option value="year">
                                                        year
                                                      </option>
                                                      <option value="month">
                                                        month
                                                      </option>
                                                    </select>
                                                  </div>
                                                </div>
                                              )
                                            )}
                                        </div>
                                      </div>
                                    </div>
                                  </div>

                                  {/* FIELD: SIZE*/}
                                  {/* <div class="col-md-12 p-0">
                                  <div class="row align-items-center">
                                    <div class="col-md-auto label-standard-w">
                                      <label for="">{"Size"}</label>
                                    </div>
                                    <div class={["p-0", "col-md-3"].join(" ")}>
                                      <div className="col-md-12">
                                        <div className={data.priceQuoteMethod !== "MULTIPLE" ? "col-md-5 d-flex" : "col-md-3"}>
                                          <input
                                            type="text"
                                            name="minimum"
                                            size={"3"}
                                            maxLength ="2"
                                            className="form-control"
                                            value={data.size.minimum}
                                            onChange={e =>
                                              this.updateSize(
                                                e.target.name,
                                                e.target.value,
                                                i
                                              )
                                            }
                                            readOnly={this.state.disabled}
                                          />
                                          { data.priceQuoteMethod !== "MULTIPLE" &&
                                            <div className="col-md-2">
                                              <label>Yrs</label>
                                            </div>
                                          }
                                        </div>
                                        {data.priceQuoteMethod ==
                                          "MULTIPLE" && (
                                          <Fragment>
                                            {" "}
                                            <div className="col-md-1 nopadding text-center">
                                              -
                                            </div>
                                            <div className={data.priceQuoteMethod === "MULTIPLE" ? "col-md-3 nopadding d-flex" : "col-md-3 nopadding"}>
                                              <input
                                                type="text"
                                                name="maximum"
                                                size={"3"}
                                                maxLength ="2"
                                                value={data.size.maximum}
                                                className="form-control"
                                                onChange={e =>
                                                  this.updateSize(
                                                    e.target.name,
                                                    e.target.value,
                                                    i
                                                  )
                                                }
                                                readOnly={this.state.disabled}
                                              />
                                              { data.priceQuoteMethod === "MULTIPLE" &&
                                                <div className="col-md-2">
                                                  <label>Yrs</label>
                                                </div>
                                              }
                                            </div>
                                          </Fragment>
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                </div> */}
                                  {/* FIELD: STATUS */}
                                  {/* <Field
                                      inputname="status"
                                      label="Status"
                                      inputType="select"
                                      options={
                                        this.state
                                          .statusOption
                                      }
                                      index={i}
                                      inputSizeClass="col-md-3"
                                      value={
                                        data.status
                                      }
                                      onChange={
                                        this
                                          .departmentDynamicChange
                                      }
                                      readOnly={
                                        this.state
                                          .disabled
                                      }
                                    /> */}
                                  <div class="col-md-6 p-0">
                                    <div class="row align-items-center">
                                      <div class="col-md-auto label-standard-w">
                                        <label for="">{"Status"}</label>
                                      </div>
                                      <div
                                        class={["p-0", "col-md-3"].join(" ")}
                                      >
                                        <Field1
                                          isFormGroup={false}
                                          inputType="checkbox"
                                          inputName={"deptstatus" + i}
                                          value={data.status}
                                          className=""
                                          onChange={(name, value) =>
                                            this.departmentDynamicChange(
                                              "status",
                                              value,
                                              i
                                            )
                                          }
                                          disabled={this.state.disabled}
                                        />
                                      </div>
                                    </div>
                                  </div>
                                  {/* STAFF */}
                                  <div class="upload-container br-col mt-1">
                                    <h6 class="fw-600 my-3 text-center">
                                      {" "}
                                      Staff
                                    </h6>
                                    <div className="col-md-12 p-0 mb-5">
                                      <table className="staff-table text-center">
                                        <tr>
                                          <th>First Name</th>
                                          <th>Last Name</th>
                                          <th>Designation</th>
                                          <th>Email Id</th>
                                          <th>Reporting to</th>
                                          <th>Office</th>
                                          <th>Employee status</th>
                                          <th />
                                        </tr>
                                        {data.staff.map((s, count) => {
                                          return (
                                            <tr>
                                              <td>
                                                <input
                                                  type="text"
                                                  className="form-control"
                                                  readOnly={this.state.disabled}
                                                  onChange={e =>
                                                    this.staffDynamicChange(
                                                      "firstName",
                                                      e.target.value,
                                                      count,
                                                      i
                                                    )
                                                  }
                                                  value={s.firstName}
                                                />
                                              </td>
                                              <td>
                                                <input
                                                  type="text"
                                                  className="form-control"
                                                  readOnly={this.state.disabled}
                                                  onChange={e =>
                                                    this.staffDynamicChange(
                                                      "lastName",
                                                      e.target.value,
                                                      count,
                                                      i
                                                    )
                                                  }
                                                  value={s.lastName}
                                                />
                                              </td>
                                              <td>
                                                <select
                                                  name=""
                                                  id=""
                                                  className="form-control"
                                                  readOnly={this.state.disabled}
                                                  onChange={e =>
                                                    this.staffDynamicChange(
                                                      "designation",
                                                      e.target.value,
                                                      count,
                                                      i
                                                    )
                                                  }
                                                  value={s.designation}
                                                >
                                                  <option value={""}>
                                                    {"--select--"}
                                                  </option>
                                                  {this.state.designationOption.map(
                                                    (data, i) => (
                                                      <option
                                                        value={data.value}
                                                      >
                                                        {data.label}
                                                      </option>
                                                    )
                                                  )}
                                                </select>
                                              </td>
                                              <td>
                                                <input
                                                  type="text"
                                                  className="form-control"
                                                  readOnly={this.state.disabled}
                                                  onChange={e =>
                                                    this.staffDynamicChange(
                                                      "email",
                                                      e.target.value,
                                                      count,
                                                      i
                                                    )
                                                  }
                                                  value={s.email}
                                                />
                                              </td>
                                              <td>
                                                <input
                                                  type="text"
                                                  className="form-control"
                                                  readOnly={this.state.disabled}
                                                  onChange={e =>
                                                    this.staffDynamicChange(
                                                      "reportingTo",
                                                      e.target.value,
                                                      count,
                                                      i
                                                    )
                                                  }
                                                  value={s.reportingTo}
                                                />
                                              </td>
                                              <td>
                                                <select
                                                  name="office"
                                                  id="office"
                                                  className="form-control"
                                                  readOnly={this.state.disabled}
                                                  onChange={e =>
                                                    this.staffDynamicChange(
                                                      "office",
                                                      e.target.value,
                                                      count,
                                                      i
                                                    )
                                                  }
                                                  value={s.office}
                                                >
                                                  <option value={""}>
                                                    {"--select--"}
                                                  </option>
                                                  {this.state.officeOption.map(
                                                    (data, i) => (
                                                      <option
                                                        value={data.value}
                                                      >
                                                        {data.label}
                                                      </option>
                                                    )
                                                  )}
                                                </select>
                                              </td>
                                              <td>
                                                <Field1
                                                  isFormGroup={false}
                                                  inputType="checkbox"
                                                  inputName={
                                                    "employeestatus" + i + count
                                                  }
                                                  value={s.status}
                                                  className="form-control_2 text-center d-flex flex-column align-items-center mt-0 pt-0"
                                                  onChange={(name, value) =>
                                                    this.staffDynamicChange(
                                                      "status",
                                                      value,
                                                      count,
                                                      i
                                                    )
                                                  }
                                                  disabled={this.state.disabled}
                                                />
                                                {/* <select
                                                      name="status"
                                                      id="status"
                                                      className="form-control"
                                                      readOnly={
                                                        this
                                                          .state
                                                          .disabled
                                                      }
                                                      onChange={e =>
                                                        this.staffDynamicChange(
                                                          "status",
                                                          e
                                                            .target
                                                            .value,
                                                          count,
                                                          i
                                                        )
                                                      }
                                                      value={
                                                        s.status
                                                      }
                                                    >
                                                      {this.state.statusOption.map(
                                                        (
                                                          data,
                                                          i
                                                        ) => (
                                                          <option
                                                            value={
                                                              data.value
                                                            }
                                                          >
                                                            {
                                                              data.label
                                                            }
                                                          </option>
                                                        )
                                                      )}
                                                    </select> */}
                                              </td>
                                              {!this.state.disabled && (
                                                <td className="d-flex justify-content-center">
                                                  {count === 0 ? (
                                                    <Button
                                                      buttonType="add"
                                                      onClick={e =>
                                                        this.dynamicAddCount(
                                                          e,
                                                          "staff",
                                                          i,
                                                          count
                                                        )
                                                      }
                                                    />
                                                  ) : (
                                                      <Button
                                                        buttonType="remove"
                                                        onClick={e =>
                                                          this.dynamicRemoveCount(
                                                            e,
                                                            "staff",
                                                            i,
                                                            count
                                                          )
                                                        }
                                                      />
                                                    )}
                                                </td>
                                              )}
                                            </tr>
                                          )
                                        })}
                                      </table>
                                    </div>
                                  </div>
                                </Fragment>
                              )}
                            </div>
                            <div className="Field-toggle-wrapper">
                              {/* DYNAMIC ADD */}
                              {!this.state.disabled && i === 0 && (
                                <Button
                                  buttonType="add"
                                  onClick={e =>
                                    this.dynamicAddCount(e, "department")
                                  }
                                />
                              )}
                              {/* DYNAMIC REMOVE */}
                              {!this.state.disabled && i !== 0 && (
                                <Button
                                  buttonType="remove"
                                  onClick={e =>
                                    this.dynamicRemoveCount(e, "department", i)
                                  }
                                />
                              )}
                            </div>
                          </div>
                        </div>
                      )
                    })}
                    </Fragment>
                    )}
                    {(this.hasPermission1("customer", "withoutpoms", this.state.action, "web") || this.hasPermission1("customer","masterpom", this.state.action, "web")) &&(
                    <div class="col-md-12 p-0 text-center">
                      <Button
                        buttonName={"save"}
                        buttonType={"save"}
                        onClick={this.onSave}
                      />
                      <Button
                        buttonName={"cancel"}
                        buttonType={"cancel"}
                        history={this.props.history}
                      />
                    </div>
                    )}
                  </form>
                </div>
                {/* FORM END */}
              </div>
              {/* PAGE CONTENT END */}
            </div>
          </div>
        </div>
        <br />
        <br />
        <Modal
          open={this.state.openModal}
          onClose={() => this.setState({ openModal: false })}
        >
          {this.state.modalType == "assign"
            ? assignModalContent
            : this.state.modalType == "trimpack"
              ? trimPackModal
              : null}
        </Modal>
      </Fragment>
    )
  }
}


const mapStateToProps = state => {
  return {
      toggle: state.Header.toggle,  // Getting 'toggle' from 'Header' slice of state
      rights: state.main.rights     // Getting 'rights' from 'main' slice of state
  }
}

export default withRouter(connect(mapStateToProps)(Customer));


// WEBPACK FOOTER //
// ./src/pages/Customer/page.js